/* tslint:disable */
/* eslint-disable */
/**
 * HP SureAdmin KMS API
 * A REST API used to provide key management services for creating and managing keys, usage permissions as well as signing payloads.
 *
 * The version of the OpenAPI document: 3.4.0.1
 * Contact: sureadminengineering@hp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AddSecretRequestDto
 */
export interface AddSecretRequestDto {
    /**
     * Specifies the unique secret name
     * @type {string}
     * @memberof AddSecretRequestDto
     */
    'Name': string;
    /**
     * Specifies the unique secret value
     * @type {string}
     * @memberof AddSecretRequestDto
     */
    'Value': string;
    /**
     * Specifies the secret type
     * @type {string}
     * @memberof AddSecretRequestDto
     */
    'type'?: AddSecretRequestDtoTypeEnum;
    /**
     * Specifies the secret expiration date in UTC format
     * @type {string}
     * @memberof AddSecretRequestDto
     */
    'ExpirationDate'?: string | null;
}

export const AddSecretRequestDtoTypeEnum = {
    Unknown: 'Unknown',
    Bap: 'BAP'
} as const;

export type AddSecretRequestDtoTypeEnum = typeof AddSecretRequestDtoTypeEnum[keyof typeof AddSecretRequestDtoTypeEnum];

/**
 * 
 * @export
 * @interface BaseCommandRequestDto
 */
export interface BaseCommandRequestDto {
    /**
     * Enrollment key (KEK) that authorizes the key rotation command for provisioning a device. Represents Azure identifier for the key base64 encoded
     * @type {string}
     * @memberof BaseCommandRequestDto
     */
    'currentKeyId': string | null;
    /**
     * Represents the nonce value
     * @type {number}
     * @memberof BaseCommandRequestDto
     */
    'nonce': number | null;
    /**
     * UUID of the target device
     * @type {Array<string>}
     * @memberof BaseCommandRequestDto
     */
    'targetUUIDs': Array<string> | null;
}
/**
 * 
 * @export
 * @interface CommandSignatureRequestDto
 */
export interface CommandSignatureRequestDto {
    /**
     * Azure identifier for the key base64 encoded to be used to generate the wpt command signature
     * @type {string}
     * @memberof CommandSignatureRequestDto
     */
    'keyId': string;
    /**
     * Base64 encoded string that is used to sign the payload in order to generate the wpt command signature
     * @type {string}
     * @memberof CommandSignatureRequestDto
     */
    'commandBlob': string;
}
/**
 * 
 * @export
 * @interface CommandSignatureResponseDto
 */
export interface CommandSignatureResponseDto {
    /**
     * Base64 encoded string that is used to sign the payload in order to generate the WPT command signature
     * @type {string}
     * @memberof CommandSignatureResponseDto
     */
    'commandBlob': string;
    /**
     * Base64 encoded string of the signature of the payload
     * @type {string}
     * @memberof CommandSignatureResponseDto
     */
    'signature': string;
}
/**
 * 
 * @export
 * @interface CommandSupervisorKeySignatureRequestDto
 */
export interface CommandSupervisorKeySignatureRequestDto {
    /**
     * Azure identifier for the threshold key base64 encoded to be used to generate the WPT command signature
     * @type {string}
     * @memberof CommandSupervisorKeySignatureRequestDto
     */
    'thresholdKeyId': string;
    /**
     * Base64 encoded string (ThresholdKey Signature + Command) that is used to sign the payload in order to generate the supervisor key command signature
     * @type {string}
     * @memberof CommandSupervisorKeySignatureRequestDto
     */
    'commandBlob': string;
    /**
     * Azure identifier for the key base64 encoded to be used to generate the wpt command signature
     * @type {string}
     * @memberof CommandSupervisorKeySignatureRequestDto
     */
    'keyId': string;
}
/**
 * 
 * @export
 * @interface DeleteKeyRequestDto
 */
export interface DeleteKeyRequestDto {
    /**
     * Azure identifier for the key base64 encoded
     * @type {string}
     * @memberof DeleteKeyRequestDto
     */
    'keyId'?: string;
}
/**
 * 
 * @export
 * @interface DeviceKeyMappingsRequestDto
 */
export interface DeviceKeyMappingsRequestDto {
    /**
     * Unique identifier for the device. It is a string of alphanumeric characters, hyphen, and underscore.
     * @type {string}
     * @memberof DeviceKeyMappingsRequestDto
     */
    'deviceId'?: string;
    /**
     * User email address
     * @type {string}
     * @memberof DeviceKeyMappingsRequestDto
     */
    'userEmailAddress'?: string;
    /**
     * Identifier used to validate if the user is authorized to use the key. Not applicable for client credentials flow.
     * @type {string}
     * @memberof DeviceKeyMappingsRequestDto
     */
    'adGroupName'?: string;
    /**
     * Identifies the date time when the key was last used.
     * @type {string}
     * @memberof DeviceKeyMappingsRequestDto
     */
    'lastUsed'?: string | null;
    /**
     * Identifies the date time when the key was imported.
     * @type {string}
     * @memberof DeviceKeyMappingsRequestDto
     */
    'importedOn'?: string;
    /**
     * Identifies the date time when the key was last updated.
     * @type {string}
     * @memberof DeviceKeyMappingsRequestDto
     */
    'updatedOn'?: string | null;
    /**
     * The partition key is a unique identifier for the partition within a given table.
     * @type {string}
     * @memberof DeviceKeyMappingsRequestDto
     */
    'partitionKey'?: string;
    /**
     * The row key is a unique identifier for an entity within a given partition.
     * @type {string}
     * @memberof DeviceKeyMappingsRequestDto
     */
    'rowKey'?: string;
    /**
     * The timestamp when the entity was last modified.
     * @type {string}
     * @memberof DeviceKeyMappingsRequestDto
     */
    'timestamp'?: string;
    /**
     * Identifier for a specific version of a resource. It lets caches be more efficient and save bandwidth.
     * @type {string}
     * @memberof DeviceKeyMappingsRequestDto
     */
    'eTag'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceKeyMappingsRequestDto
     */
    'UserEmailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof DeviceKeyMappingsRequestDto
     */
    'ADGroupName': string;
}
/**
 * 
 * @export
 * @interface DeviceKeyMappingsRequestDtoAnyOf
 */
export interface DeviceKeyMappingsRequestDtoAnyOf {
    /**
     * 
     * @type {string}
     * @memberof DeviceKeyMappingsRequestDtoAnyOf
     */
    'UserEmailAddress': string;
}
/**
 * 
 * @export
 * @interface DeviceKeyMappingsRequestDtoAnyOf1
 */
export interface DeviceKeyMappingsRequestDtoAnyOf1 {
    /**
     * 
     * @type {string}
     * @memberof DeviceKeyMappingsRequestDtoAnyOf1
     */
    'ADGroupName': string;
}
/**
 * 
 * @export
 * @interface DeviceKeyMappingsResponseDto
 */
export interface DeviceKeyMappingsResponseDto {
    /**
     * Unique identifier for the device. It is a string of alphanumeric characters, hyphen, and underscore.
     * @type {string}
     * @memberof DeviceKeyMappingsResponseDto
     */
    'deviceId': string;
    /**
     * User email address
     * @type {string}
     * @memberof DeviceKeyMappingsResponseDto
     */
    'userEmailAddress'?: string;
    /**
     * Identifier used to validate if the user is authorized to use the key. Not applicable for client credentials flow.
     * @type {string}
     * @memberof DeviceKeyMappingsResponseDto
     */
    'adGroupName'?: string;
    /**
     * Identifies the date time when the key was last used.
     * @type {string}
     * @memberof DeviceKeyMappingsResponseDto
     */
    'lastUsed': string | null;
    /**
     * Identifies the date time when the key was imported.
     * @type {string}
     * @memberof DeviceKeyMappingsResponseDto
     */
    'importedOn': string;
    /**
     * Identifies the date time when the key was last updated.
     * @type {string}
     * @memberof DeviceKeyMappingsResponseDto
     */
    'updatedOn': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceKeyMappingsResponseDto
     */
    'isValid'?: boolean;
    /**
     * The partition key is a unique identifier for the partition within a given table.
     * @type {string}
     * @memberof DeviceKeyMappingsResponseDto
     */
    'partitionKey'?: string;
    /**
     * The row key is a unique identifier for an entity within a given partition.
     * @type {string}
     * @memberof DeviceKeyMappingsResponseDto
     */
    'rowKey'?: string;
    /**
     * The timestamp when the entity was last modified.
     * @type {string}
     * @memberof DeviceKeyMappingsResponseDto
     */
    'timestamp'?: string;
    /**
     * Identifier for a specific version of a resource. It lets caches be more efficient and save bandwidth.
     * @type {string}
     * @memberof DeviceKeyMappingsResponseDto
     */
    'eTag'?: string;
}
/**
 * 
 * @export
 * @interface EndorsementKeyRequestDto
 */
export interface EndorsementKeyRequestDto {
    /**
     * Represents key enrollment data. Phone app will use this data element, if there isn’t a matching key locally and it isn’t an empty string, to locate the private key on OneDrive.
     * @type {string}
     * @memberof EndorsementKeyRequestDto
     */
    'keyEnrollmentData'?: string | null;
    /**
     * 10 digits UNIX time that represents key expiration.
     * @type {string}
     * @memberof EndorsementKeyRequestDto
     */
    'KeyExp'?: string | null;
    /**
     * Represents whether a key is backed up in cloud.
     * @type {string}
     * @memberof EndorsementKeyRequestDto
     */
    'KeyBkupEn'?: string | null;
    /**
     * Indicates whether a key backup can be modified in cloud.
     * @type {string}
     * @memberof EndorsementKeyRequestDto
     */
    'CanModKeyBkup'?: string | null;
    /**
     * Indicates whether keys can be exported.
     * @type {string}
     * @memberof EndorsementKeyRequestDto
     */
    'CanExport'?: string | null;
    /**
     * Used to identify version#.
     * @type {string}
     * @memberof EndorsementKeyRequestDto
     */
    'Ver': string;
    /**
     * Used to identify type of QR code which informs which the QR reader which fields are required -vs- optional and what the default are for optional fields that are not present.
     * @type {string}
     * @memberof EndorsementKeyRequestDto
     */
    'Type': string;
    /**
     * Azure identifier for the key base64 encoded.
     * @type {string}
     * @memberof EndorsementKeyRequestDto
     */
    'KeyId': string;
    /**
     * Represents private key algorithm.
     * @type {string}
     * @memberof EndorsementKeyRequestDto
     */
    'KeyAlgo': string;
    /**
     * Base64 encoded string sent as part of enrollment QR code. Not used for challenge-response QR codes.
     * @type {string}
     * @memberof EndorsementKeyRequestDto
     */
    'PvtKey': string;
    /**
     * The Key name.
     * @type {string}
     * @memberof EndorsementKeyRequestDto
     */
    'KeyName': string;
    /**
     * Identifier used to validate if the user is authorized to use the key. Not applicable for client credentials flow.
     * @type {string}
     * @memberof EndorsementKeyRequestDto
     */
    'AadRevocation': string;
}
/**
 * 
 * @export
 * @interface EnrollmentKeyEntityRequestDto
 */
export interface EnrollmentKeyEntityRequestDto {
    /**
     * The Key name
     * @type {string}
     * @memberof EnrollmentKeyEntityRequestDto
     */
    'keyName': string;
    /**
     * Azure identifier for the key base64 encoded
     * @type {string}
     * @memberof EnrollmentKeyEntityRequestDto
     */
    'keyId': string;
    /**
     * Identifier used to validate if the user is authorized to use the key.
     * @type {string}
     * @memberof EnrollmentKeyEntityRequestDto
     */
    'aadRevocation': string | null;
    /**
     * Identifier for a specific version of a resource. It lets caches be more efficient and save bandwidth.
     * @type {string}
     * @memberof EnrollmentKeyEntityRequestDto
     */
    'eTag': string;
}
/**
 * 
 * @export
 * @interface EnrollmentKeyRequestDto
 */
export interface EnrollmentKeyRequestDto {
    /**
     * Represents key enrollment data. Phone app will use this data element, if there isn’t a matching key locally and it isn’t an empty string, to locate the private key on OneDrive.
     * @type {string}
     * @memberof EnrollmentKeyRequestDto
     */
    'keyEnrollmentData'?: string | null;
    /**
     * 10 digits UNIX time that represents key expiration.
     * @type {string}
     * @memberof EnrollmentKeyRequestDto
     */
    'KeyExp'?: string | null;
    /**
     * Represents whether a key is backed up in cloud.
     * @type {string}
     * @memberof EnrollmentKeyRequestDto
     */
    'KeyBkupEn'?: string | null;
    /**
     * Indicates whether a key backup can be modified in cloud.
     * @type {string}
     * @memberof EnrollmentKeyRequestDto
     */
    'CanModKeyBkup'?: string | null;
    /**
     * Indicates whether keys can be exported.
     * @type {string}
     * @memberof EnrollmentKeyRequestDto
     */
    'CanExport'?: string | null;
    /**
     * Used to identify version#.
     * @type {string}
     * @memberof EnrollmentKeyRequestDto
     */
    'Ver': string;
    /**
     * Used to identify type of QR code which informs which the QR reader which fields are required -vs- optional and what the default are for optional fields that are not present.
     * @type {string}
     * @memberof EnrollmentKeyRequestDto
     */
    'Type': string;
    /**
     * Azure identifier for the key base64 encoded.
     * @type {string}
     * @memberof EnrollmentKeyRequestDto
     */
    'KeyId': string;
    /**
     * Represents private key algorithm.
     * @type {string}
     * @memberof EnrollmentKeyRequestDto
     */
    'KeyAlgo': string;
    /**
     * Base64 encoded string sent as part of enrollment QR code. Not used for challenge-response QR codes.
     * @type {string}
     * @memberof EnrollmentKeyRequestDto
     */
    'PvtKey': string;
    /**
     * The Key name.
     * @type {string}
     * @memberof EnrollmentKeyRequestDto
     */
    'KeyName': string;
    /**
     * Identifier used to validate if the user is authorized to use the key. Not applicable for client credentials flow.
     * @type {string}
     * @memberof EnrollmentKeyRequestDto
     */
    'AadRevocation': string;
}
/**
 * 
 * @export
 * @interface EntraIdRoleRequestDto
 */
export interface EntraIdRoleRequestDto {
    /**
     * Specifies the Entra ID role unique Id
     * @type {string}
     * @memberof EntraIdRoleRequestDto
     */
    'id'?: string;
    /**
     * Name of the role
     * @type {string}
     * @memberof EntraIdRoleRequestDto
     */
    'entraIdName': string;
    /**
     * Indicates if the role allows creating a key
     * @type {boolean}
     * @memberof EntraIdRoleRequestDto
     */
    'createKey': boolean;
    /**
     * Indicates if the role allows rotating a key
     * @type {boolean}
     * @memberof EntraIdRoleRequestDto
     */
    'rotateKey': boolean;
    /**
     * Indicates if the role allows retrieving a key
     * @type {boolean}
     * @memberof EntraIdRoleRequestDto
     */
    'getKey': boolean;
    /**
     * Indicates if the role allows deleting a key
     * @type {boolean}
     * @memberof EntraIdRoleRequestDto
     */
    'deleteKey': boolean;
    /**
     * Indicates if the role allows adding a role
     * @type {boolean}
     * @memberof EntraIdRoleRequestDto
     */
    'addPermission': boolean;
    /**
     * Indicates if the role allows updating a role
     * @type {boolean}
     * @memberof EntraIdRoleRequestDto
     */
    'updatePermission': boolean;
    /**
     * Indicates if the role allows retrieving a role
     * @type {boolean}
     * @memberof EntraIdRoleRequestDto
     */
    'getPermission': boolean;
    /**
     * Indicates if the role allows deleting a role
     * @type {boolean}
     * @memberof EntraIdRoleRequestDto
     */
    'deletePermission': boolean;
    /**
     * Indicates if the role allows creating a secret
     * @type {boolean}
     * @memberof EntraIdRoleRequestDto
     */
    'createSecret': boolean;
    /**
     * Indicates if the role allows retrieving a secret
     * @type {boolean}
     * @memberof EntraIdRoleRequestDto
     */
    'getSecret': boolean;
    /**
     * Indicates if the role allows deleting a secret
     * @type {boolean}
     * @memberof EntraIdRoleRequestDto
     */
    'deleteSecret': boolean;
    /**
     * Indicates if the role is for Entra ID group roles
     * @type {boolean}
     * @memberof EntraIdRoleRequestDto
     */
    'entraIDGroupRoles': boolean;
}
/**
 * 
 * @export
 * @interface EntraIdRoleResponseDto
 */
export interface EntraIdRoleResponseDto {
    /**
     * Name of the permission
     * @type {string}
     * @memberof EntraIdRoleResponseDto
     */
    'entraIdName': string;
    /**
     * Specifies the entra id role unique Id
     * @type {string}
     * @memberof EntraIdRoleResponseDto
     */
    'id': string;
    /**
     * Indicates if the role allows creating a key
     * @type {boolean}
     * @memberof EntraIdRoleResponseDto
     */
    'createKey': boolean;
    /**
     * Indicates if the Entra ID role allows rotating a key
     * @type {boolean}
     * @memberof EntraIdRoleResponseDto
     */
    'rotateKey': boolean;
    /**
     * Indicates if the Entra ID role allows retrieving a key
     * @type {boolean}
     * @memberof EntraIdRoleResponseDto
     */
    'getKey': boolean;
    /**
     * Indicates if the Entra ID role allows deleting a key
     * @type {boolean}
     * @memberof EntraIdRoleResponseDto
     */
    'deleteKey': boolean;
    /**
     * Indicates if the Entra ID role allows adding a permission
     * @type {boolean}
     * @memberof EntraIdRoleResponseDto
     */
    'addPermission': boolean;
    /**
     * Indicates if the Entra ID role allows updating a permission
     * @type {boolean}
     * @memberof EntraIdRoleResponseDto
     */
    'updatePermission': boolean;
    /**
     * Indicates if the Entra ID role allows retrieving a permission
     * @type {boolean}
     * @memberof EntraIdRoleResponseDto
     */
    'getPermission': boolean;
    /**
     * Indicates if the Entra ID role allows deleting a permission
     * @type {boolean}
     * @memberof EntraIdRoleResponseDto
     */
    'deletePermission': boolean;
    /**
     * Indicates if the role allows adding a secret
     * @type {boolean}
     * @memberof EntraIdRoleResponseDto
     */
    'createSecret': boolean;
    /**
     * Indicates if the role allows retrieving a secret
     * @type {boolean}
     * @memberof EntraIdRoleResponseDto
     */
    'getSecret': boolean;
    /**
     * Indicates if the role allows deleting a secret
     * @type {boolean}
     * @memberof EntraIdRoleResponseDto
     */
    'deleteSecret': boolean;
    /**
     * Indicates if the permission is for Entra ID roles
     * @type {boolean}
     * @memberof EntraIdRoleResponseDto
     */
    'entraIDGroupRoles': boolean;
    /**
     * Specifies the date and time the Entra ID role was last updated
     * @type {string}
     * @memberof EntraIdRoleResponseDto
     */
    'lastUpdated'?: string;
}
/**
 * 
 * @export
 * @interface ErrorResponseDto
 */
export interface ErrorResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseDto
     */
    'stackTrace'?: string | null;
    /**
     * Represents the error code that is returned while generating the authorization command
     * @type {number}
     * @memberof ErrorResponseDto
     */
    'errorCode': ErrorResponseDtoErrorCodeEnum;
    /**
     * The error message that explains the reason for the exception
     * @type {string}
     * @memberof ErrorResponseDto
     */
    'message': string | null;
    /**
     * The exception that is the cause of the current exception
     * @type {string}
     * @memberof ErrorResponseDto
     */
    'innerException'?: string | null;
    /**
     * Link to the help file associated with this exception
     * @type {string}
     * @memberof ErrorResponseDto
     */
    'helpLink'?: string | null;
    /**
     * The name of the application or the object that causes the error
     * @type {string}
     * @memberof ErrorResponseDto
     */
    'source'?: string | null;
    /**
     * A coded numerical value that is assigned to a specific exception
     * @type {number}
     * @memberof ErrorResponseDto
     */
    'hResult': number | null;
}

export const ErrorResponseDtoErrorCodeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_100: 100,
    NUMBER_101: 101,
    NUMBER_102: 102,
    NUMBER_103: 103,
    NUMBER_104: 104,
    NUMBER_105: 105,
    NUMBER_106: 106,
    NUMBER_107: 107,
    NUMBER_108: 108,
    NUMBER_200: 200,
    NUMBER_201: 201,
    NUMBER_203: 203,
    NUMBER_206: 206,
    NUMBER_300: 300,
    NUMBER_301: 301,
    NUMBER_302: 302,
    NUMBER_303: 303,
    NUMBER_304: 304,
    NUMBER_305: 305,
    NUMBER_401: 401,
    NUMBER_402: 402,
    NUMBER_403: 403,
    NUMBER_404: 404,
    NUMBER_405: 405,
    NUMBER_406: 406,
    NUMBER_407: 407,
    NUMBER_408: 408,
    NUMBER_409: 409,
    NUMBER_410: 410,
    NUMBER_411: 411,
    NUMBER_412: 412,
    NUMBER_413: 413,
    NUMBER_414: 414,
    NUMBER_415: 415,
    NUMBER_416: 416,
    NUMBER_417: 417,
    NUMBER_418: 418,
    NUMBER_419: 419,
    NUMBER_420: 420,
    NUMBER_430: 430,
    NUMBER_431: 431,
    NUMBER_432: 432,
    NUMBER_433: 433,
    NUMBER_434: 434,
    NUMBER_435: 435,
    NUMBER_436: 436,
    NUMBER_437: 437,
    NUMBER_438: 438,
    NUMBER_439: 439,
    NUMBER_440: 440,
    NUMBER_501: 501,
    NUMBER_502: 502,
    NUMBER_503: 503,
    NUMBER_504: 504,
    NUMBER_601: 601,
    NUMBER_602: 602,
    NUMBER_603: 603,
    NUMBER_604: 604,
    NUMBER_605: 605,
    NUMBER_606: 606,
    NUMBER_607: 607
} as const;

export type ErrorResponseDtoErrorCodeEnum = typeof ErrorResponseDtoErrorCodeEnum[keyof typeof ErrorResponseDtoErrorCodeEnum];

/**
 * 
 * @export
 * @interface GenerateKeyRequestDto
 */
export interface GenerateKeyRequestDto {
    /**
     * The Key name
     * @type {string}
     * @memberof GenerateKeyRequestDto
     */
    'keyName': string | null;
    /**
     * Identifier used to validate if the user is authorized to use the key. Not applicable for client credentials flow.
     * @type {string}
     * @memberof GenerateKeyRequestDto
     */
    'aadRevocation'?: string | null;
}
/**
 * 
 * @export
 * @interface GenerateKeyResponseDto
 */
export interface GenerateKeyResponseDto {
    /**
     * The Key name
     * @type {string}
     * @memberof GenerateKeyResponseDto
     */
    'keyName': string | null;
    /**
     * Azure identifier for the key base64 encoded
     * @type {string}
     * @memberof GenerateKeyResponseDto
     */
    'keyId': string | null;
    /**
     * Identifier used to validate if the user is authorized to use the key. Not applicable for client credentials flow.
     * @type {string}
     * @memberof GenerateKeyResponseDto
     */
    'aadRevocation'?: string | null;
    /**
     * Public key base64 encoded
     * @type {string}
     * @memberof GenerateKeyResponseDto
     */
    'publicKey': string | null;
    /**
     * Identifier for a specific version of a resource. It lets caches be more efficient and save bandwidth.
     * @type {string}
     * @memberof GenerateKeyResponseDto
     */
    'eTag': string | null;
}
/**
 * 
 * @export
 * @interface GenericKeyResponseDto
 */
export interface GenericKeyResponseDto {
    /**
     * The Key name
     * @type {string}
     * @memberof GenericKeyResponseDto
     */
    'keyName': string;
    /**
     * Azure identifier for the key base64 encoded
     * @type {string}
     * @memberof GenericKeyResponseDto
     */
    'keyId': string;
    /**
     * Identifier used to validate if the user is authorized to use the key. Not applicable for client credentials flow.
     * @type {string}
     * @memberof GenericKeyResponseDto
     */
    'aadRevocation'?: string | null;
    /**
     * ISO 8601 format date time inc timezone
     * @type {string}
     * @memberof GenericKeyResponseDto
     */
    'lastAccessed': string | null;
    /**
     * Unix timestamp
     * @type {number}
     * @memberof GenericKeyResponseDto
     */
    'importDate': number;
    /**
     * Sanitized and Hashed KeyId using SHA 256 Algorithm
     * @type {string}
     * @memberof GenericKeyResponseDto
     */
    'rowKey': string;
    /**
     * Identifier for a specific version of a resource. It lets caches be more efficient and save bandwidth.
     * @type {string}
     * @memberof GenericKeyResponseDto
     */
    'eTag': string;
    /**
     * Public key base64 encoded
     * @type {string}
     * @memberof GenericKeyResponseDto
     */
    'publicKey': string | null;
}
/**
 * 
 * @export
 * @interface GetCapabilitiesResponseDto
 */
export interface GetCapabilitiesResponseDto {
    /**
     * Specifies the device key mappings enabled
     * @type {boolean}
     * @memberof GetCapabilitiesResponseDto
     */
    'deviceKeyMappingsEnabled'?: boolean;
    /**
     * Specifies the signing key enabled
     * @type {boolean}
     * @memberof GetCapabilitiesResponseDto
     */
    'signingKeyEnabled'?: boolean;
    /**
     * Specifies the remote signing commands enabled
     * @type {boolean}
     * @memberof GetCapabilitiesResponseDto
     */
    'remoteSigningCommandsEnabled'?: boolean;
    /**
     * Specifies the endorsement key enabled
     * @type {boolean}
     * @memberof GetCapabilitiesResponseDto
     */
    'endorsementKeyEnabled'?: boolean;
    /**
     * Specifies the wolf security is enabled
     * @type {boolean}
     * @memberof GetCapabilitiesResponseDto
     */
    'wolfSecuritySupportEnabled'?: boolean;
    /**
     * Specifies the sure recover is enabled
     * @type {boolean}
     * @memberof GetCapabilitiesResponseDto
     */
    'sureRecoverSupportEnabled'?: boolean;
    /**
     * 
     * @type {KeysInUseResponseDto}
     * @memberof GetCapabilitiesResponseDto
     */
    'keysInUse'?: KeysInUseResponseDto;
}
/**
 * 
 * @export
 * @interface GetKeysRequestDto
 */
export interface GetKeysRequestDto {
    /**
     * Azure identifier for the key base64 encoded
     * @type {string}
     * @memberof GetKeysRequestDto
     */
    'keyId'?: string | null;
    /**
     * The Key name
     * @type {string}
     * @memberof GetKeysRequestDto
     */
    'keyName'?: string | null;
    /**
     * Identifier used to validate if the user is authorized to use the key. Not applicable for client credentials flow.
     * @type {string}
     * @memberof GetKeysRequestDto
     */
    'aadRevocation'?: string | null;
    /**
     * Continuation key used for pagination in order to get large set of data
     * @type {string}
     * @memberof GetKeysRequestDto
     */
    'continuationTokenKey'?: string | null;
    /**
     * 
     * @type {TableContinuationTokenDto}
     * @memberof GetKeysRequestDto
     */
    'continuationToken'?: TableContinuationTokenDto | null;
    /**
     * 
     * @type {string}
     * @memberof GetKeysRequestDto
     */
    'KeyName': string;
    /**
     * 
     * @type {string}
     * @memberof GetKeysRequestDto
     */
    'AadRevocation': string;
}
/**
 * 
 * @export
 * @interface GetKeysRequestDtoAnyOf
 */
export interface GetKeysRequestDtoAnyOf {
    /**
     * 
     * @type {string}
     * @memberof GetKeysRequestDtoAnyOf
     */
    'keyId': string;
}
/**
 * 
 * @export
 * @interface GetKeysRequestDtoAnyOf1
 */
export interface GetKeysRequestDtoAnyOf1 {
    /**
     * 
     * @type {string}
     * @memberof GetKeysRequestDtoAnyOf1
     */
    'KeyName': string;
}
/**
 * 
 * @export
 * @interface GetKeysRequestDtoAnyOf2
 */
export interface GetKeysRequestDtoAnyOf2 {
    /**
     * 
     * @type {string}
     * @memberof GetKeysRequestDtoAnyOf2
     */
    'AadRevocation': string;
}
/**
 * 
 * @export
 * @interface GetP21CommandSignatureRequestDto
 */
export interface GetP21CommandSignatureRequestDto {
    /**
     * Azure identifier for the key base64 encoded to be used to generate the P21 command signature
     * @type {string}
     * @memberof GetP21CommandSignatureRequestDto
     */
    'keyId': string;
    /**
     * Base64 encoded string that is used to sign the payload in order to generate the signature
     * @type {string}
     * @memberof GetP21CommandSignatureRequestDto
     */
    'commandBlob': string;
}
/**
 * 
 * @export
 * @interface GetP21CommandSignatureResponseDto
 */
export interface GetP21CommandSignatureResponseDto {
    /**
     * Base64 encoded string that is used to sign the payload in order to generate the signature
     * @type {string}
     * @memberof GetP21CommandSignatureResponseDto
     */
    'commandBlob': string;
    /**
     * Base64 encoded string of the signature of the payload
     * @type {string}
     * @memberof GetP21CommandSignatureResponseDto
     */
    'signature': string;
}
/**
 * 
 * @export
 * @interface GetP21EKPublicCertRequestDto
 */
export interface GetP21EKPublicCertRequestDto {
    /**
     * Azure identifier for the endorsement key base64 encoded to be used to generate the P21 EK public certificate
     * @type {string}
     * @memberof GetP21EKPublicCertRequestDto
     */
    'ekId': string;
}
/**
 * 
 * @export
 * @interface GetP21SKProvisioningPayloadRequestDto
 */
export interface GetP21SKProvisioningPayloadRequestDto {
    /**
     * Azure identifier for the signing key base64 encoded to be used to generate the P21 provisioning payload
     * @type {string}
     * @memberof GetP21SKProvisioningPayloadRequestDto
     */
    'skId'?: string | null;
    /**
     * Azure identifier for the endorsement key base64 encoded to be used to generate the P21 provisioning payload
     * @type {string}
     * @memberof GetP21SKProvisioningPayloadRequestDto
     */
    'ekId'?: string;
    /**
     * Represents the nonce value
     * @type {number}
     * @memberof GetP21SKProvisioningPayloadRequestDto
     */
    'nonce'?: number;
}
/**
 * 
 * @export
 * @interface GetP21SKProvisioningPayloadResponseDto
 */
export interface GetP21SKProvisioningPayloadResponseDto {
    /**
     * Unix timestamp
     * @type {string}
     * @memberof GetP21SKProvisioningPayloadResponseDto
     */
    'timestamp'?: string;
    /**
     * Purpose of generating the payload
     * @type {string}
     * @memberof GetP21SKProvisioningPayloadResponseDto
     */
    'purpose'?: string;
    /**
     * Data section of the payload
     * @type {Array<number>}
     * @memberof GetP21SKProvisioningPayloadResponseDto
     */
    'data'?: Array<number>;
    /**
     * Meta 1 section of the payload
     * @type {File}
     * @memberof GetP21SKProvisioningPayloadResponseDto
     */
    'meta1'?: File;
    /**
     * Meta 2 section of the payload
     * @type {File}
     * @memberof GetP21SKProvisioningPayloadResponseDto
     */
    'meta2'?: File;
    /**
     * Meta 3 section of the payload
     * @type {File}
     * @memberof GetP21SKProvisioningPayloadResponseDto
     */
    'meta3'?: File;
    /**
     * Meta 4 section of the payload
     * @type {File}
     * @memberof GetP21SKProvisioningPayloadResponseDto
     */
    'meta4'?: File;
}
/**
 * 
 * @export
 * @interface GetSureAdminAuthRequestDto
 */
export interface GetSureAdminAuthRequestDto {
    /**
     * Azure identifier for the key base64 encoded
     * @type {string}
     * @memberof GetSureAdminAuthRequestDto
     */
    'keyId': string;
    /**
     * 
     * @type {Array<SureAdminSettingRequestDto>}
     * @memberof GetSureAdminAuthRequestDto
     */
    'settings': Array<SureAdminSettingRequestDto>;
}
/**
 * 
 * @export
 * @interface GetSureAdminAuthResponseDto
 */
export interface GetSureAdminAuthResponseDto {
    /**
     * 
     * @type {Array<SureAdminSettingResponseDto>}
     * @memberof GetSureAdminAuthResponseDto
     */
    'settings'?: Array<SureAdminSettingResponseDto>;
}
/**
 * 
 * @export
 * @interface KeyEntityResponseDto
 */
export interface KeyEntityResponseDto {
    /**
     * The Key name
     * @type {string}
     * @memberof KeyEntityResponseDto
     */
    'keyName': string;
    /**
     * Azure identifier for the key base64 encoded
     * @type {string}
     * @memberof KeyEntityResponseDto
     */
    'keyId': string;
    /**
     * Identifier used to validate if the user is authorized to use the key. Not applicable for client credentials flow.
     * @type {string}
     * @memberof KeyEntityResponseDto
     */
    'aadRevocation'?: string | null;
    /**
     * ISO 8601 format date time inc timezone
     * @type {string}
     * @memberof KeyEntityResponseDto
     */
    'lastAccessed': string | null;
    /**
     * Unix timestamp
     * @type {number}
     * @memberof KeyEntityResponseDto
     */
    'importDate': number;
    /**
     * Sanitized and Hashed KeyId using SHA 256 Algorithm
     * @type {string}
     * @memberof KeyEntityResponseDto
     */
    'rowKey': string;
    /**
     * Identifier for a specific version of a resource. It lets caches be more efficient and save bandwidth.
     * @type {string}
     * @memberof KeyEntityResponseDto
     */
    'eTag': string;
    /**
     * Public key base64 encoded
     * @type {string}
     * @memberof KeyEntityResponseDto
     */
    'publicKey': string | null;
}
/**
 * 
 * @export
 * @interface KeyRequestDto
 */
export interface KeyRequestDto {
    /**
     * The new value for the Key name
     * @type {string}
     * @memberof KeyRequestDto
     */
    'keyName': string;
    /**
     * The user group with access to the key
     * @type {string}
     * @memberof KeyRequestDto
     */
    'aadRevocation': string;
    /**
     * The last known modified datetime for the key. If different to the stored value in KMS, the update will be rejected with a 400 error
     * @type {string}
     * @memberof KeyRequestDto
     */
    'eTag': string;
}
/**
 * Specifies the Keys in use.
 * @export
 * @interface KeysInUseResponseDto
 */
export interface KeysInUseResponseDto {
    /**
     * Indicates whether Local Access Keys are in use.
     * @type {boolean}
     * @memberof KeysInUseResponseDto
     */
    'localAccesKeys'?: boolean;
    /**
     * Indicates whether Signing Keys are in use.
     * @type {boolean}
     * @memberof KeysInUseResponseDto
     */
    'signingKeys'?: boolean;
    /**
     * Indicates whether Endorsement Keys are in use.
     * @type {boolean}
     * @memberof KeysInUseResponseDto
     */
    'endorsementKeys'?: boolean;
    /**
     * Indicates whether Supervisor Keys are in use.
     * @type {boolean}
     * @memberof KeysInUseResponseDto
     */
    'supervisorKeys'?: boolean;
    /**
     * Indicates whether Threshold Keys are in use.
     * @type {boolean}
     * @memberof KeysInUseResponseDto
     */
    'thresholdKeys'?: boolean;
    /**
     * Indicates whether Tenant Keys are in use.
     * @type {boolean}
     * @memberof KeysInUseResponseDto
     */
    'tenantKeys'?: boolean;
}
/**
 * 
 * @export
 * @interface KeysResponseDto
 */
export interface KeysResponseDto {
    /**
     * 
     * @type {Array<KeyEntityResponseDto>}
     * @memberof KeysResponseDto
     */
    'keys'?: Array<KeyEntityResponseDto>;
    /**
     * Continuation key used for pagination in order to get large set of data
     * @type {string}
     * @memberof KeysResponseDto
     */
    'continuationTokenKey'?: string | null;
    /**
     * 
     * @type {TableContinuationToken}
     * @memberof KeysResponseDto
     */
    'continuationToken'?: TableContinuationToken | null;
}
/**
 * 
 * @export
 * @interface RotateKeyRequestDto
 */
export interface RotateKeyRequestDto {
    /**
     * Enrollment (KEK) or signing key (SK) used for provisioning a device. Represents Azure identifier for the key base64 encoded
     * @type {string}
     * @memberof RotateKeyRequestDto
     */
    'newKeyId': string | null;
    /**
     * Enrollment key (KEK) that authorizes the key rotation command for provisioning a device. Represents Azure identifier for the key base64 encoded
     * @type {string}
     * @memberof RotateKeyRequestDto
     */
    'currentKeyId': string | null;
    /**
     * Represents the nonce value
     * @type {number}
     * @memberof RotateKeyRequestDto
     */
    'nonce': number | null;
    /**
     * UUID of the target device
     * @type {Array<string>}
     * @memberof RotateKeyRequestDto
     */
    'targetUUIDs': Array<string> | null;
}
/**
 * 
 * @export
 * @interface RotateKeyResponseDto
 */
export interface RotateKeyResponseDto {
    /**
     * Base64 encoded command structure that enables to change to either new KEK or SK or deprovision a device by removing the KEK on the device authorized using the private portion of the key.
     * @type {string}
     * @memberof RotateKeyResponseDto
     */
    'command': string | null;
}
/**
 * 
 * @export
 * @interface SearchKeyMappingsRequestDto
 */
export interface SearchKeyMappingsRequestDto {
    /**
     * Unique identifier for the device. It is a string of alphanumeric characters, hyphen, and underscore.
     * @type {string}
     * @memberof SearchKeyMappingsRequestDto
     */
    'deviceId'?: string | null;
    /**
     * User email address
     * @type {string}
     * @memberof SearchKeyMappingsRequestDto
     */
    'userEmailAddress'?: string | null;
    /**
     * Identifier used to validate if the user is authorized to use the key. Not applicable for client credentials flow.
     * @type {string}
     * @memberof SearchKeyMappingsRequestDto
     */
    'adGroupName'?: string | null;
    /**
     * Continuation key used for pagination in order to get large set of data
     * @type {string}
     * @memberof SearchKeyMappingsRequestDto
     */
    'continuationTokenKey'?: string | null;
    /**
     * 
     * @type {TableContinuationTokenDto}
     * @memberof SearchKeyMappingsRequestDto
     */
    'continuationToken'?: TableContinuationTokenDto | null;
    /**
     * 
     * @type {string}
     * @memberof SearchKeyMappingsRequestDto
     */
    'DeviceId': string;
    /**
     * 
     * @type {string}
     * @memberof SearchKeyMappingsRequestDto
     */
    'UserEmailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof SearchKeyMappingsRequestDto
     */
    'ADGroupName': string;
}
/**
 * 
 * @export
 * @interface SearchKeyMappingsRequestDtoAnyOf
 */
export interface SearchKeyMappingsRequestDtoAnyOf {
    /**
     * 
     * @type {string}
     * @memberof SearchKeyMappingsRequestDtoAnyOf
     */
    'DeviceId': string;
}
/**
 * 
 * @export
 * @interface SearchKeyMappingsResponseDto
 */
export interface SearchKeyMappingsResponseDto {
    /**
     * List of device key mappings
     * @type {Array<DeviceKeyMappingsResponseDto>}
     * @memberof SearchKeyMappingsResponseDto
     */
    'deviceKeyMappings'?: Array<DeviceKeyMappingsResponseDto>;
    /**
     * Continuation key used for pagination in order to get large set of data
     * @type {string}
     * @memberof SearchKeyMappingsResponseDto
     */
    'continuationTokenKey'?: string | null;
    /**
     * 
     * @type {TableContinuationTokenDto}
     * @memberof SearchKeyMappingsResponseDto
     */
    'continuationToken'?: TableContinuationTokenDto | null;
}
/**
 * 
 * @export
 * @interface SearchKeysResponseDtoEndorsementKeyEntity
 */
export interface SearchKeysResponseDtoEndorsementKeyEntity {
    /**
     * List of device key mappings
     * @type {Array<GenericKeyResponseDto>}
     * @memberof SearchKeysResponseDtoEndorsementKeyEntity
     */
    'keys'?: Array<GenericKeyResponseDto>;
    /**
     * Continuation key used for pagination in order to get large set of data
     * @type {string}
     * @memberof SearchKeysResponseDtoEndorsementKeyEntity
     */
    'continuationTokenKey'?: string | null;
    /**
     * 
     * @type {TableContinuationToken}
     * @memberof SearchKeysResponseDtoEndorsementKeyEntity
     */
    'continuationToken'?: TableContinuationToken | null;
}
/**
 * 
 * @export
 * @interface SearchKeysResponseDtoSigningKeyEntity
 */
export interface SearchKeysResponseDtoSigningKeyEntity {
    /**
     * List of device key mappings
     * @type {Array<GenericKeyResponseDto>}
     * @memberof SearchKeysResponseDtoSigningKeyEntity
     */
    'keys'?: Array<GenericKeyResponseDto>;
    /**
     * Continuation key used for pagination in order to get large set of data
     * @type {string}
     * @memberof SearchKeysResponseDtoSigningKeyEntity
     */
    'continuationTokenKey'?: string | null;
    /**
     * 
     * @type {TableContinuationToken}
     * @memberof SearchKeysResponseDtoSigningKeyEntity
     */
    'continuationToken'?: TableContinuationToken | null;
}
/**
 * 
 * @export
 * @interface SearchSecretsRequestDto
 */
export interface SearchSecretsRequestDto {
    /**
     * Specifies the secret type
     * @type {string}
     * @memberof SearchSecretsRequestDto
     */
    'type'?: SearchSecretsRequestDtoTypeEnum;
    /**
     * Continuation key used for pagination in order to get large set of data
     * @type {string}
     * @memberof SearchSecretsRequestDto
     */
    'continuationTokenKey'?: string | null;
}

export const SearchSecretsRequestDtoTypeEnum = {
    Unknown: 'Unknown',
    Bap: 'BAP'
} as const;

export type SearchSecretsRequestDtoTypeEnum = typeof SearchSecretsRequestDtoTypeEnum[keyof typeof SearchSecretsRequestDtoTypeEnum];

/**
 * 
 * @export
 * @interface SearchSecretsResponseDto
 */
export interface SearchSecretsResponseDto {
    /**
     * List of secrets
     * @type {Array<SecretResponseMetadataDto>}
     * @memberof SearchSecretsResponseDto
     */
    'secrets'?: Array<SecretResponseMetadataDto>;
    /**
     * Cursor used for pagination in order to get large set of data
     * @type {string}
     * @memberof SearchSecretsResponseDto
     */
    'continuationTokenKey'?: string | null;
}
/**
 * 
 * @export
 * @interface SearchUsagePermissionsRequestDto
 */
export interface SearchUsagePermissionsRequestDto {
    /**
     * Specifies the usage or the purpose of the permission
     * @type {string}
     * @memberof SearchUsagePermissionsRequestDto
     */
    'usage'?: string | null;
    /**
     * Specifies the entra Id group
     * @type {string}
     * @memberof SearchUsagePermissionsRequestDto
     */
    'entraIDGroup'?: string | null;
    /**
     * Specifies the email address
     * @type {string}
     * @memberof SearchUsagePermissionsRequestDto
     */
    'emails'?: string | null;
    /**
     * Continuation key used for pagination in order to get large set of data
     * @type {string}
     * @memberof SearchUsagePermissionsRequestDto
     */
    'continuationTokenKey'?: string | null;
}
/**
 * 
 * @export
 * @interface SearchUsagePermissionsResponseDto
 */
export interface SearchUsagePermissionsResponseDto {
    /**
     * List of usage permissions
     * @type {Array<UsagePermissionResponseDto>}
     * @memberof SearchUsagePermissionsResponseDto
     */
    'usagePermissions'?: Array<UsagePermissionResponseDto>;
    /**
     * Cursor used for pagination in order to get large set of data
     * @type {string}
     * @memberof SearchUsagePermissionsResponseDto
     */
    'continuationTokenKey'?: string | null;
}
/**
 * 
 * @export
 * @interface SecretResponseDto
 */
export interface SecretResponseDto {
    /**
     * Specifies the unique secret value
     * @type {string}
     * @memberof SecretResponseDto
     */
    'value'?: string;
    /**
     * Specifies the unique secret id
     * @type {string}
     * @memberof SecretResponseDto
     */
    'id'?: string;
    /**
     * Specifies the unique secret name
     * @type {string}
     * @memberof SecretResponseDto
     */
    'name'?: string;
    /**
     * Specifies the secret type
     * @type {string}
     * @memberof SecretResponseDto
     */
    'type'?: SecretResponseDtoTypeEnum;
    /**
     * Specifies the date and time the secret was created. ISO 8601 format date time inc time zone.
     * @type {string}
     * @memberof SecretResponseDto
     */
    'dateCreated'?: string;
    /**
     * Specifies the date and time the secret was last updated. ISO 8601 format date time inc time zone.
     * @type {string}
     * @memberof SecretResponseDto
     */
    'LastUpdated'?: string | null;
    /**
     * Specifies the secret expiration date in UTC format.
     * @type {string}
     * @memberof SecretResponseDto
     */
    'ExpirationDate'?: string | null;
}

export const SecretResponseDtoTypeEnum = {
    Unknown: 'Unknown',
    Bap: 'BAP'
} as const;

export type SecretResponseDtoTypeEnum = typeof SecretResponseDtoTypeEnum[keyof typeof SecretResponseDtoTypeEnum];

/**
 * 
 * @export
 * @interface SecretResponseMetadataDto
 */
export interface SecretResponseMetadataDto {
    /**
     * Specifies the unique secret id
     * @type {string}
     * @memberof SecretResponseMetadataDto
     */
    'id'?: string;
    /**
     * Specifies the unique secret name
     * @type {string}
     * @memberof SecretResponseMetadataDto
     */
    'name'?: string;
    /**
     * Specifies the secret type
     * @type {string}
     * @memberof SecretResponseMetadataDto
     */
    'type'?: SecretResponseMetadataDtoTypeEnum;
    /**
     * Specifies the date and time the secret was created. ISO 8601 format date time inc time zone.
     * @type {string}
     * @memberof SecretResponseMetadataDto
     */
    'dateCreated'?: string;
    /**
     * Specifies the date and time the secret was last updated. ISO 8601 format date time inc time zone.
     * @type {string}
     * @memberof SecretResponseMetadataDto
     */
    'LastUpdated'?: string | null;
    /**
     * Specifies the secret expiration date in UTC format.
     * @type {string}
     * @memberof SecretResponseMetadataDto
     */
    'ExpirationDate'?: string | null;
}

export const SecretResponseMetadataDtoTypeEnum = {
    Unknown: 'Unknown',
    Bap: 'BAP'
} as const;

export type SecretResponseMetadataDtoTypeEnum = typeof SecretResponseMetadataDtoTypeEnum[keyof typeof SecretResponseMetadataDtoTypeEnum];

/**
 * 
 * @export
 * @interface SigningKeyRequestDto
 */
export interface SigningKeyRequestDto {
    /**
     * Represents key enrollment data. Phone app will use this data element, if there isn’t a matching key locally and it isn’t an empty string, to locate the private key on OneDrive.
     * @type {string}
     * @memberof SigningKeyRequestDto
     */
    'keyEnrollmentData'?: string | null;
    /**
     * 10 digits UNIX time that represents key expiration.
     * @type {string}
     * @memberof SigningKeyRequestDto
     */
    'KeyExp'?: string | null;
    /**
     * Represents whether a key is backed up in cloud.
     * @type {string}
     * @memberof SigningKeyRequestDto
     */
    'KeyBkupEn'?: string | null;
    /**
     * Indicates whether a key backup can be modified in cloud.
     * @type {string}
     * @memberof SigningKeyRequestDto
     */
    'CanModKeyBkup'?: string | null;
    /**
     * Indicates whether keys can be exported.
     * @type {string}
     * @memberof SigningKeyRequestDto
     */
    'CanExport'?: string | null;
    /**
     * Used to identify version#.
     * @type {string}
     * @memberof SigningKeyRequestDto
     */
    'Ver': string;
    /**
     * Used to identify type of QR code which informs which the QR reader which fields are required -vs- optional and what the default are for optional fields that are not present.
     * @type {string}
     * @memberof SigningKeyRequestDto
     */
    'Type': string;
    /**
     * Azure identifier for the key base64 encoded.
     * @type {string}
     * @memberof SigningKeyRequestDto
     */
    'KeyId': string;
    /**
     * Represents private key algorithm.
     * @type {string}
     * @memberof SigningKeyRequestDto
     */
    'KeyAlgo': string;
    /**
     * Base64 encoded string sent as part of enrollment QR code. Not used for challenge-response QR codes.
     * @type {string}
     * @memberof SigningKeyRequestDto
     */
    'PvtKey': string;
    /**
     * The Key name.
     * @type {string}
     * @memberof SigningKeyRequestDto
     */
    'KeyName': string;
    /**
     * Identifier used to validate if the user is authorized to use the key. Not applicable for client credentials flow.
     * @type {string}
     * @memberof SigningKeyRequestDto
     */
    'AadRevocation': string;
}
/**
 * 
 * @export
 * @interface SureAdminSettingRequestDto
 */
export interface SureAdminSettingRequestDto {
    /**
     * Represents the name of the setting
     * @type {string}
     * @memberof SureAdminSettingRequestDto
     */
    'name': string;
    /**
     * Represents the value of the setting. Format is base64 encoded string for Allowed BIOS Update Hash
     * @type {string}
     * @memberof SureAdminSettingRequestDto
     */
    'value': string;
    /**
     * Represents whether the setting is for single use or not
     * @type {boolean}
     * @memberof SureAdminSettingRequestDto
     */
    'isSingleUse'?: boolean;
    /**
     * Represents the nonce value
     * @type {number}
     * @memberof SureAdminSettingRequestDto
     */
    'nonce'?: number;
    /**
     * UUID of the target device
     * @type {string}
     * @memberof SureAdminSettingRequestDto
     */
    'targetUUID'?: string;
}
/**
 * 
 * @export
 * @interface SureAdminSettingResponseDto
 */
export interface SureAdminSettingResponseDto {
    /**
     * Represents the name of the setting
     * @type {string}
     * @memberof SureAdminSettingResponseDto
     */
    'name': string;
    /**
     * Represents the value of the setting. Format is base64 encoded string for Allowed BIOS Update Hash
     * @type {string}
     * @memberof SureAdminSettingResponseDto
     */
    'value': string;
    /**
     * Represents the authorization command string
     * @type {string}
     * @memberof SureAdminSettingResponseDto
     */
    'authString'?: string;
    /**
     * Represents the error code
     * @type {string}
     * @memberof SureAdminSettingResponseDto
     */
    'errorCode'?: string | null;
}
/**
 * Cursor used for pagination in order to get large set of data
 * @export
 * @interface TableContinuationToken
 */
export interface TableContinuationToken {
    /**
     * 
     * @type {string}
     * @memberof TableContinuationToken
     */
    'nextPartitionKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof TableContinuationToken
     */
    'nextRowKey'?: string;
}
/**
 * Cursor used for pagination in order to get large set of data
 * @export
 * @interface TableContinuationTokenDto
 */
export interface TableContinuationTokenDto {
    /**
     * 
     * @type {string}
     * @memberof TableContinuationTokenDto
     */
    'nextPartitionKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof TableContinuationTokenDto
     */
    'nextRowKey'?: string;
}
/**
 * 
 * @export
 * @interface UnlockPinRequestDto
 */
export interface UnlockPinRequestDto {
    /**
     * Represents the payload sent as part of challenge response for local access. Payload contains version#, type, usage, keyid, epin, dPin, KeyAlgo, model, sernum, uuid, keyname, importDate, keyEnrollmentData.
     * @type {string}
     * @memberof UnlockPinRequestDto
     */
    'Payload': string;
}
/**
 * 
 * @export
 * @interface UsagePermissionRequestDto
 */
export interface UsagePermissionRequestDto {
    /**
     * Specifies the usage or the purpose of the permission
     * @type {string}
     * @memberof UsagePermissionRequestDto
     */
    'usage'?: string;
    /**
     * Specifies the entra Id group
     * @type {string}
     * @memberof UsagePermissionRequestDto
     */
    'entraIDGroup'?: string | null;
    /**
     * Specifies the email address
     * @type {string}
     * @memberof UsagePermissionRequestDto
     */
    'emails'?: string | null;
}
/**
 * 
 * @export
 * @interface UsagePermissionResponseDto
 */
export interface UsagePermissionResponseDto {
    /**
     * Specifies the usage permission unique Id
     * @type {string}
     * @memberof UsagePermissionResponseDto
     */
    'id'?: string;
    /**
     * Specifies the usage or the purpose of the permission
     * @type {string}
     * @memberof UsagePermissionResponseDto
     */
    'usage'?: string;
    /**
     * Specifies the entra Id group
     * @type {string}
     * @memberof UsagePermissionResponseDto
     */
    'entraIDGroup': string | null;
    /**
     * Specifies the email address
     * @type {string}
     * @memberof UsagePermissionResponseDto
     */
    'emails': string | null;
    /**
     * Specifies the date and time the permission was last updated
     * @type {string}
     * @memberof UsagePermissionResponseDto
     */
    'updatedOn': string | null;
    /**
     * Specifies the date and time the permission was last used
     * @type {string}
     * @memberof UsagePermissionResponseDto
     */
    'lastUsed': string | null;
    /**
     * Specifies the time the permission was last used
     * @type {string}
     * @memberof UsagePermissionResponseDto
     */
    'timestamp': string | null;
}
/**
 * 
 * @export
 * @interface UserPermissionsResponseDto
 */
export interface UserPermissionsResponseDto {
    /**
     * Specifies whether user has access to get keys
     * @type {boolean}
     * @memberof UserPermissionsResponseDto
     */
    'hasGetKeysAccess'?: boolean;
    /**
     * Specifies whether user has access to delete keys
     * @type {boolean}
     * @memberof UserPermissionsResponseDto
     */
    'hasDeleteKeysAccess'?: boolean;
    /**
     * Specifies whether user has access to update keys
     * @type {boolean}
     * @memberof UserPermissionsResponseDto
     */
    'hasUpdateKeysAccess'?: boolean;
    /**
     * Specifies whether user has access to upload keys
     * @type {boolean}
     * @memberof UserPermissionsResponseDto
     */
    'hasUploadKeysAccess'?: boolean;
    /**
     * Specifies whether user has access to add permissions
     * @type {boolean}
     * @memberof UserPermissionsResponseDto
     */
    'hasAddPermissionsAccess'?: boolean;
    /**
     * Specifies whether user has access to delete permissions
     * @type {boolean}
     * @memberof UserPermissionsResponseDto
     */
    'hasDeletePermissionsAccess'?: boolean;
    /**
     * Specifies whether user has access to get permissions
     * @type {boolean}
     * @memberof UserPermissionsResponseDto
     */
    'hasGetPermissionsAccess'?: boolean;
    /**
     * Specifies whether user has access to update permissions
     * @type {boolean}
     * @memberof UserPermissionsResponseDto
     */
    'hasUpdatePermissionsAccess'?: boolean;
    /**
     * Specifies whether user has access to rotate permissions
     * @type {boolean}
     * @memberof UserPermissionsResponseDto
     */
    'hasRotateKeysAccess'?: boolean;
    /**
     * Specifies whether user has Entra ID roles
     * @type {boolean}
     * @memberof UserPermissionsResponseDto
     */
    'hasEntraIDRolesAccess'?: boolean;
}

/**
 * CapabilitiesApi - axios parameter creator
 * @export
 */
export const CapabilitiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a list of features or capabilities supported by the current Key Management System (KMS) Instance.
         * @summary Returns all capabilties
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCapabilities: async (xKMSClient?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/capabilities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CapabilitiesApi - functional programming interface
 * @export
 */
export const CapabilitiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CapabilitiesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a list of features or capabilities supported by the current Key Management System (KMS) Instance.
         * @summary Returns all capabilties
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCapabilities(xKMSClient?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCapabilitiesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCapabilities(xKMSClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CapabilitiesApi.getCapabilities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CapabilitiesApi - factory interface
 * @export
 */
export const CapabilitiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CapabilitiesApiFp(configuration)
    return {
        /**
         * Returns a list of features or capabilities supported by the current Key Management System (KMS) Instance.
         * @summary Returns all capabilties
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCapabilities(xKMSClient?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetCapabilitiesResponseDto> {
            return localVarFp.getCapabilities(xKMSClient, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CapabilitiesApi - object-oriented interface
 * @export
 * @class CapabilitiesApi
 * @extends {BaseAPI}
 */
export class CapabilitiesApi extends BaseAPI {
    /**
     * Returns a list of features or capabilities supported by the current Key Management System (KMS) Instance.
     * @summary Returns all capabilties
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CapabilitiesApi
     */
    public getCapabilities(xKMSClient?: string, options?: RawAxiosRequestConfig) {
        return CapabilitiesApiFp(this.configuration).getCapabilities(xKMSClient, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CommandsApi - axios parameter creator
 * @export
 */
export const CommandsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the signature for a specific command blob based on a valid signing key, endorsement key or tenant key
         * @summary Returns P21 command signature
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GetP21CommandSignatureRequestDto} [getP21CommandSignatureRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandsP21CommandSignature: async (xKMSClient?: string, getP21CommandSignatureRequestDto?: GetP21CommandSignatureRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commands/p21signature`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getP21CommandSignatureRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a public key certificate of the endorsement key in DER base 64 format.
         * @summary Returns P21 EK Public Certificate
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GetP21EKPublicCertRequestDto} [getP21EKPublicCertRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandsP21EKPublicCert: async (xKMSClient?: string, getP21EKPublicCertRequestDto?: GetP21EKPublicCertRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commands/p21EKPublicCert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getP21EKPublicCertRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a base64 encoded string payload to provision the signing key into the device with endorsement key.
         * @summary Returns P21 provisioning payload auth strings
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GetP21SKProvisioningPayloadRequestDto} [getP21SKProvisioningPayloadRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandsP21SKProvisioningPayload: async (xKMSClient?: string, getP21SKProvisioningPayloadRequestDto?: GetP21SKProvisioningPayloadRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commands/p21SKprovisioningpayload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getP21SKProvisioningPayloadRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns an AuthString for all requested BIOS settings. which is needed to create a payload to change BIOS settings.
         * @summary Get Sure Admin auth strings
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GetSureAdminAuthRequestDto} [getSureAdminAuthRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandsSureAdminAuth: async (xKMSClient?: string, getSureAdminAuthRequestDto?: GetSureAdminAuthRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commands/sureadminauth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getSureAdminAuthRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the signature for a threshold command with a supervisor key
         * @summary Returns signed command signature
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {CommandSupervisorKeySignatureRequestDto} [commandSupervisorKeySignatureRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandsWPTCommandSupervisorKeySignature: async (xKMSClient?: string, commandSupervisorKeySignatureRequestDto?: CommandSupervisorKeySignatureRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commands/wpt/supervisorkey-signature`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandSupervisorKeySignatureRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the signature for a threshold command blob based on a valid threshold key.
         * @summary Returns a Signed command
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {CommandSignatureRequestDto} [commandSignatureRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandsWPTCommandThresholdKeySignature: async (xKMSClient?: string, commandSignatureRequestDto?: CommandSignatureRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commands/wpt/thresholdkey-signature`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandSignatureRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommandsApi - functional programming interface
 * @export
 */
export const CommandsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommandsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the signature for a specific command blob based on a valid signing key, endorsement key or tenant key
         * @summary Returns P21 command signature
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GetP21CommandSignatureRequestDto} [getP21CommandSignatureRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commandsP21CommandSignature(xKMSClient?: string, getP21CommandSignatureRequestDto?: GetP21CommandSignatureRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetP21CommandSignatureResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commandsP21CommandSignature(xKMSClient, getP21CommandSignatureRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommandsApi.commandsP21CommandSignature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a public key certificate of the endorsement key in DER base 64 format.
         * @summary Returns P21 EK Public Certificate
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GetP21EKPublicCertRequestDto} [getP21EKPublicCertRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commandsP21EKPublicCert(xKMSClient?: string, getP21EKPublicCertRequestDto?: GetP21EKPublicCertRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commandsP21EKPublicCert(xKMSClient, getP21EKPublicCertRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommandsApi.commandsP21EKPublicCert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a base64 encoded string payload to provision the signing key into the device with endorsement key.
         * @summary Returns P21 provisioning payload auth strings
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GetP21SKProvisioningPayloadRequestDto} [getP21SKProvisioningPayloadRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commandsP21SKProvisioningPayload(xKMSClient?: string, getP21SKProvisioningPayloadRequestDto?: GetP21SKProvisioningPayloadRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetP21SKProvisioningPayloadResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commandsP21SKProvisioningPayload(xKMSClient, getP21SKProvisioningPayloadRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommandsApi.commandsP21SKProvisioningPayload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns an AuthString for all requested BIOS settings. which is needed to create a payload to change BIOS settings.
         * @summary Get Sure Admin auth strings
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GetSureAdminAuthRequestDto} [getSureAdminAuthRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commandsSureAdminAuth(xKMSClient?: string, getSureAdminAuthRequestDto?: GetSureAdminAuthRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSureAdminAuthResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commandsSureAdminAuth(xKMSClient, getSureAdminAuthRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommandsApi.commandsSureAdminAuth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the signature for a threshold command with a supervisor key
         * @summary Returns signed command signature
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {CommandSupervisorKeySignatureRequestDto} [commandSupervisorKeySignatureRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commandsWPTCommandSupervisorKeySignature(xKMSClient?: string, commandSupervisorKeySignatureRequestDto?: CommandSupervisorKeySignatureRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandSignatureResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commandsWPTCommandSupervisorKeySignature(xKMSClient, commandSupervisorKeySignatureRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommandsApi.commandsWPTCommandSupervisorKeySignature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the signature for a threshold command blob based on a valid threshold key.
         * @summary Returns a Signed command
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {CommandSignatureRequestDto} [commandSignatureRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commandsWPTCommandThresholdKeySignature(xKMSClient?: string, commandSignatureRequestDto?: CommandSignatureRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandSignatureResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commandsWPTCommandThresholdKeySignature(xKMSClient, commandSignatureRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CommandsApi.commandsWPTCommandThresholdKeySignature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CommandsApi - factory interface
 * @export
 */
export const CommandsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommandsApiFp(configuration)
    return {
        /**
         * Returns the signature for a specific command blob based on a valid signing key, endorsement key or tenant key
         * @summary Returns P21 command signature
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GetP21CommandSignatureRequestDto} [getP21CommandSignatureRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandsP21CommandSignature(xKMSClient?: string, getP21CommandSignatureRequestDto?: GetP21CommandSignatureRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<GetP21CommandSignatureResponseDto> {
            return localVarFp.commandsP21CommandSignature(xKMSClient, getP21CommandSignatureRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a public key certificate of the endorsement key in DER base 64 format.
         * @summary Returns P21 EK Public Certificate
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GetP21EKPublicCertRequestDto} [getP21EKPublicCertRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandsP21EKPublicCert(xKMSClient?: string, getP21EKPublicCertRequestDto?: GetP21EKPublicCertRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.commandsP21EKPublicCert(xKMSClient, getP21EKPublicCertRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a base64 encoded string payload to provision the signing key into the device with endorsement key.
         * @summary Returns P21 provisioning payload auth strings
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GetP21SKProvisioningPayloadRequestDto} [getP21SKProvisioningPayloadRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandsP21SKProvisioningPayload(xKMSClient?: string, getP21SKProvisioningPayloadRequestDto?: GetP21SKProvisioningPayloadRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<GetP21SKProvisioningPayloadResponseDto> {
            return localVarFp.commandsP21SKProvisioningPayload(xKMSClient, getP21SKProvisioningPayloadRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns an AuthString for all requested BIOS settings. which is needed to create a payload to change BIOS settings.
         * @summary Get Sure Admin auth strings
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GetSureAdminAuthRequestDto} [getSureAdminAuthRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandsSureAdminAuth(xKMSClient?: string, getSureAdminAuthRequestDto?: GetSureAdminAuthRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<GetSureAdminAuthResponseDto> {
            return localVarFp.commandsSureAdminAuth(xKMSClient, getSureAdminAuthRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the signature for a threshold command with a supervisor key
         * @summary Returns signed command signature
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {CommandSupervisorKeySignatureRequestDto} [commandSupervisorKeySignatureRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandsWPTCommandSupervisorKeySignature(xKMSClient?: string, commandSupervisorKeySignatureRequestDto?: CommandSupervisorKeySignatureRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CommandSignatureResponseDto> {
            return localVarFp.commandsWPTCommandSupervisorKeySignature(xKMSClient, commandSupervisorKeySignatureRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the signature for a threshold command blob based on a valid threshold key.
         * @summary Returns a Signed command
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {CommandSignatureRequestDto} [commandSignatureRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commandsWPTCommandThresholdKeySignature(xKMSClient?: string, commandSignatureRequestDto?: CommandSignatureRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CommandSignatureResponseDto> {
            return localVarFp.commandsWPTCommandThresholdKeySignature(xKMSClient, commandSignatureRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommandsApi - object-oriented interface
 * @export
 * @class CommandsApi
 * @extends {BaseAPI}
 */
export class CommandsApi extends BaseAPI {
    /**
     * Returns the signature for a specific command blob based on a valid signing key, endorsement key or tenant key
     * @summary Returns P21 command signature
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {GetP21CommandSignatureRequestDto} [getP21CommandSignatureRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommandsApi
     */
    public commandsP21CommandSignature(xKMSClient?: string, getP21CommandSignatureRequestDto?: GetP21CommandSignatureRequestDto, options?: RawAxiosRequestConfig) {
        return CommandsApiFp(this.configuration).commandsP21CommandSignature(xKMSClient, getP21CommandSignatureRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a public key certificate of the endorsement key in DER base 64 format.
     * @summary Returns P21 EK Public Certificate
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {GetP21EKPublicCertRequestDto} [getP21EKPublicCertRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommandsApi
     */
    public commandsP21EKPublicCert(xKMSClient?: string, getP21EKPublicCertRequestDto?: GetP21EKPublicCertRequestDto, options?: RawAxiosRequestConfig) {
        return CommandsApiFp(this.configuration).commandsP21EKPublicCert(xKMSClient, getP21EKPublicCertRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a base64 encoded string payload to provision the signing key into the device with endorsement key.
     * @summary Returns P21 provisioning payload auth strings
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {GetP21SKProvisioningPayloadRequestDto} [getP21SKProvisioningPayloadRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommandsApi
     */
    public commandsP21SKProvisioningPayload(xKMSClient?: string, getP21SKProvisioningPayloadRequestDto?: GetP21SKProvisioningPayloadRequestDto, options?: RawAxiosRequestConfig) {
        return CommandsApiFp(this.configuration).commandsP21SKProvisioningPayload(xKMSClient, getP21SKProvisioningPayloadRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns an AuthString for all requested BIOS settings. which is needed to create a payload to change BIOS settings.
     * @summary Get Sure Admin auth strings
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {GetSureAdminAuthRequestDto} [getSureAdminAuthRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommandsApi
     */
    public commandsSureAdminAuth(xKMSClient?: string, getSureAdminAuthRequestDto?: GetSureAdminAuthRequestDto, options?: RawAxiosRequestConfig) {
        return CommandsApiFp(this.configuration).commandsSureAdminAuth(xKMSClient, getSureAdminAuthRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the signature for a threshold command with a supervisor key
     * @summary Returns signed command signature
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {CommandSupervisorKeySignatureRequestDto} [commandSupervisorKeySignatureRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommandsApi
     */
    public commandsWPTCommandSupervisorKeySignature(xKMSClient?: string, commandSupervisorKeySignatureRequestDto?: CommandSupervisorKeySignatureRequestDto, options?: RawAxiosRequestConfig) {
        return CommandsApiFp(this.configuration).commandsWPTCommandSupervisorKeySignature(xKMSClient, commandSupervisorKeySignatureRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the signature for a threshold command blob based on a valid threshold key.
     * @summary Returns a Signed command
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {CommandSignatureRequestDto} [commandSignatureRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommandsApi
     */
    public commandsWPTCommandThresholdKeySignature(xKMSClient?: string, commandSignatureRequestDto?: CommandSignatureRequestDto, options?: RawAxiosRequestConfig) {
        return CommandsApiFp(this.configuration).commandsWPTCommandThresholdKeySignature(xKMSClient, commandSignatureRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DeviceKeyMappingsApi - axios parameter creator
 * @export
 */
export const DeviceKeyMappingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates and returns a new key mapping
         * @summary Creates and returns a new key mapping
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {DeviceKeyMappingsRequestDto} [deviceKeyMappingsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsAdd: async (xKMSClient?: string, deviceKeyMappingsRequestDto?: DeviceKeyMappingsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/devicekeymappings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deviceKeyMappingsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates and returns a list of new key mappings
         * @summary Bulk upload key mappings
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {Array<DeviceKeyMappingsRequestDto>} [deviceKeyMappingsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsBulkUpload: async (xKMSClient?: string, deviceKeyMappingsRequestDto?: Array<DeviceKeyMappingsRequestDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/devicekeymappings/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deviceKeyMappingsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a key mapping on a specific device id
         * @summary Deletes a key mapping based on a specific device id
         * @param {string} deviceId The device id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsDelete: async (deviceId: string, xKMSClient?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('permissionsDelete', 'deviceId', deviceId)
            const localVarPath = `/devicekeymappings/{deviceId}`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns key mapping metadata for a specific deviceId
         * @summary Returns key mapping metadata for a specific deviceId
         * @param {string} deviceId The device id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsGet: async (deviceId: string, xKMSClient?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('permissionsGet', 'deviceId', deviceId)
            const localVarPath = `/devicekeymappings/{deviceId}`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all device key mappings
         * @summary Returns all device key mappings
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {SearchKeyMappingsRequestDto} [searchKeyMappingsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsSearch: async (xKMSClient?: string, searchKeyMappingsRequestDto?: SearchKeyMappingsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/devicekeymappings/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchKeyMappingsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a key mapping based on a specific device id
         * @summary Updates a key mapping based on a specific device id
         * @param {string} deviceId The key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {DeviceKeyMappingsRequestDto} [deviceKeyMappingsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsUpdate: async (deviceId: string, xKMSClient?: string, deviceKeyMappingsRequestDto?: DeviceKeyMappingsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('permissionsUpdate', 'deviceId', deviceId)
            const localVarPath = `/devicekeymappings/{deviceId}`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deviceKeyMappingsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeviceKeyMappingsApi - functional programming interface
 * @export
 */
export const DeviceKeyMappingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeviceKeyMappingsApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates and returns a new key mapping
         * @summary Creates and returns a new key mapping
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {DeviceKeyMappingsRequestDto} [deviceKeyMappingsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionsAdd(xKMSClient?: string, deviceKeyMappingsRequestDto?: DeviceKeyMappingsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceKeyMappingsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionsAdd(xKMSClient, deviceKeyMappingsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceKeyMappingsApi.permissionsAdd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates and returns a list of new key mappings
         * @summary Bulk upload key mappings
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {Array<DeviceKeyMappingsRequestDto>} [deviceKeyMappingsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionsBulkUpload(xKMSClient?: string, deviceKeyMappingsRequestDto?: Array<DeviceKeyMappingsRequestDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeviceKeyMappingsResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionsBulkUpload(xKMSClient, deviceKeyMappingsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceKeyMappingsApi.permissionsBulkUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a key mapping on a specific device id
         * @summary Deletes a key mapping based on a specific device id
         * @param {string} deviceId The device id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionsDelete(deviceId: string, xKMSClient?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionsDelete(deviceId, xKMSClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceKeyMappingsApi.permissionsDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns key mapping metadata for a specific deviceId
         * @summary Returns key mapping metadata for a specific deviceId
         * @param {string} deviceId The device id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionsGet(deviceId: string, xKMSClient?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceKeyMappingsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionsGet(deviceId, xKMSClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceKeyMappingsApi.permissionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all device key mappings
         * @summary Returns all device key mappings
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {SearchKeyMappingsRequestDto} [searchKeyMappingsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionsSearch(xKMSClient?: string, searchKeyMappingsRequestDto?: SearchKeyMappingsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchKeyMappingsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionsSearch(xKMSClient, searchKeyMappingsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceKeyMappingsApi.permissionsSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates a key mapping based on a specific device id
         * @summary Updates a key mapping based on a specific device id
         * @param {string} deviceId The key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {DeviceKeyMappingsRequestDto} [deviceKeyMappingsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async permissionsUpdate(deviceId: string, xKMSClient?: string, deviceKeyMappingsRequestDto?: DeviceKeyMappingsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceKeyMappingsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.permissionsUpdate(deviceId, xKMSClient, deviceKeyMappingsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceKeyMappingsApi.permissionsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeviceKeyMappingsApi - factory interface
 * @export
 */
export const DeviceKeyMappingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeviceKeyMappingsApiFp(configuration)
    return {
        /**
         * Creates and returns a new key mapping
         * @summary Creates and returns a new key mapping
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {DeviceKeyMappingsRequestDto} [deviceKeyMappingsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsAdd(xKMSClient?: string, deviceKeyMappingsRequestDto?: DeviceKeyMappingsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<DeviceKeyMappingsResponseDto> {
            return localVarFp.permissionsAdd(xKMSClient, deviceKeyMappingsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates and returns a list of new key mappings
         * @summary Bulk upload key mappings
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {Array<DeviceKeyMappingsRequestDto>} [deviceKeyMappingsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsBulkUpload(xKMSClient?: string, deviceKeyMappingsRequestDto?: Array<DeviceKeyMappingsRequestDto>, options?: RawAxiosRequestConfig): AxiosPromise<Array<DeviceKeyMappingsResponseDto>> {
            return localVarFp.permissionsBulkUpload(xKMSClient, deviceKeyMappingsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a key mapping on a specific device id
         * @summary Deletes a key mapping based on a specific device id
         * @param {string} deviceId The device id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsDelete(deviceId: string, xKMSClient?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.permissionsDelete(deviceId, xKMSClient, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns key mapping metadata for a specific deviceId
         * @summary Returns key mapping metadata for a specific deviceId
         * @param {string} deviceId The device id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsGet(deviceId: string, xKMSClient?: string, options?: RawAxiosRequestConfig): AxiosPromise<DeviceKeyMappingsResponseDto> {
            return localVarFp.permissionsGet(deviceId, xKMSClient, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all device key mappings
         * @summary Returns all device key mappings
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {SearchKeyMappingsRequestDto} [searchKeyMappingsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsSearch(xKMSClient?: string, searchKeyMappingsRequestDto?: SearchKeyMappingsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SearchKeyMappingsResponseDto> {
            return localVarFp.permissionsSearch(xKMSClient, searchKeyMappingsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a key mapping based on a specific device id
         * @summary Updates a key mapping based on a specific device id
         * @param {string} deviceId The key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {DeviceKeyMappingsRequestDto} [deviceKeyMappingsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsUpdate(deviceId: string, xKMSClient?: string, deviceKeyMappingsRequestDto?: DeviceKeyMappingsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<DeviceKeyMappingsResponseDto> {
            return localVarFp.permissionsUpdate(deviceId, xKMSClient, deviceKeyMappingsRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeviceKeyMappingsApi - object-oriented interface
 * @export
 * @class DeviceKeyMappingsApi
 * @extends {BaseAPI}
 */
export class DeviceKeyMappingsApi extends BaseAPI {
    /**
     * Creates and returns a new key mapping
     * @summary Creates and returns a new key mapping
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {DeviceKeyMappingsRequestDto} [deviceKeyMappingsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceKeyMappingsApi
     */
    public permissionsAdd(xKMSClient?: string, deviceKeyMappingsRequestDto?: DeviceKeyMappingsRequestDto, options?: RawAxiosRequestConfig) {
        return DeviceKeyMappingsApiFp(this.configuration).permissionsAdd(xKMSClient, deviceKeyMappingsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates and returns a list of new key mappings
     * @summary Bulk upload key mappings
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {Array<DeviceKeyMappingsRequestDto>} [deviceKeyMappingsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceKeyMappingsApi
     */
    public permissionsBulkUpload(xKMSClient?: string, deviceKeyMappingsRequestDto?: Array<DeviceKeyMappingsRequestDto>, options?: RawAxiosRequestConfig) {
        return DeviceKeyMappingsApiFp(this.configuration).permissionsBulkUpload(xKMSClient, deviceKeyMappingsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a key mapping on a specific device id
     * @summary Deletes a key mapping based on a specific device id
     * @param {string} deviceId The device id
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceKeyMappingsApi
     */
    public permissionsDelete(deviceId: string, xKMSClient?: string, options?: RawAxiosRequestConfig) {
        return DeviceKeyMappingsApiFp(this.configuration).permissionsDelete(deviceId, xKMSClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns key mapping metadata for a specific deviceId
     * @summary Returns key mapping metadata for a specific deviceId
     * @param {string} deviceId The device id
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceKeyMappingsApi
     */
    public permissionsGet(deviceId: string, xKMSClient?: string, options?: RawAxiosRequestConfig) {
        return DeviceKeyMappingsApiFp(this.configuration).permissionsGet(deviceId, xKMSClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all device key mappings
     * @summary Returns all device key mappings
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {SearchKeyMappingsRequestDto} [searchKeyMappingsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceKeyMappingsApi
     */
    public permissionsSearch(xKMSClient?: string, searchKeyMappingsRequestDto?: SearchKeyMappingsRequestDto, options?: RawAxiosRequestConfig) {
        return DeviceKeyMappingsApiFp(this.configuration).permissionsSearch(xKMSClient, searchKeyMappingsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a key mapping based on a specific device id
     * @summary Updates a key mapping based on a specific device id
     * @param {string} deviceId The key id
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {DeviceKeyMappingsRequestDto} [deviceKeyMappingsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceKeyMappingsApi
     */
    public permissionsUpdate(deviceId: string, xKMSClient?: string, deviceKeyMappingsRequestDto?: DeviceKeyMappingsRequestDto, options?: RawAxiosRequestConfig) {
        return DeviceKeyMappingsApiFp(this.configuration).permissionsUpdate(deviceId, xKMSClient, deviceKeyMappingsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EndorsementKeysApi - axios parameter creator
 * @export
 */
export const EndorsementKeysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Adds a new endorsement key into the keyvault and storage table and return identifiers associated with it.
         * @summary Creates and returns a new endorsement key
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {EndorsementKeyRequestDto} [endorsementKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endorsementKeyAdd: async (xKMSClient?: string, endorsementKeyRequestDto?: EndorsementKeyRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/endorsementkeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(endorsementKeyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes an endorsement key from storage and keyvault.
         * @summary Deletes a given endorsement key on a specific key id
         * @param {string} keyId The key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endorsementKeyDelete: async (keyId: string, xKMSClient?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('endorsementKeyDelete', 'keyId', keyId)
            const localVarPath = `/endorsementkeys/{keyId}`
                .replace(`{${"keyId"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns endorsement key metadata excluding the private key.
         * @summary Returns endorsement key metadata for a specific keyId
         * @param {string} keyId The endorsement key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endorsementKeyGet: async (keyId: string, xKMSClient?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('endorsementKeyGet', 'keyId', keyId)
            const localVarPath = `/endorsementkeys/{keyId}`
                .replace(`{${"keyId"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the AADRevocation group and KeyName for a specific endorsement key.
         * @summary Updates an endorsement key based on a specific key id
         * @param {string} keyId The key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {KeyRequestDto} [keyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endorsementKeyUpdate: async (keyId: string, xKMSClient?: string, keyRequestDto?: KeyRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('endorsementKeyUpdate', 'keyId', keyId)
            const localVarPath = `/endorsementkeys/{keyId}`
                .replace(`{${"keyId"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(keyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uploads a new endorsement key into the keyvault and storage table and return identifiers associated with it.
         * @summary Uploads a new endorsement key
         * @param {string} file The binary file containing the key to be uploaded.
         * @param {string} keyName The Key name.
         * @param {string} aadRevocation Identifier used to validate if the user is authorized to use the key. Not applicable for client credentials flow.
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endorsementKeyUpload: async (file: string, keyName: string, aadRevocation: string, xKMSClient?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('endorsementKeyUpload', 'file', file)
            // verify required parameter 'keyName' is not null or undefined
            assertParamExists('endorsementKeyUpload', 'keyName', keyName)
            // verify required parameter 'aadRevocation' is not null or undefined
            assertParamExists('endorsementKeyUpload', 'aadRevocation', aadRevocation)
            const localVarPath = `/endorsementkeys-upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (keyName !== undefined) { 
                localVarFormParams.append('keyName', keyName as any);
            }
    
            if (aadRevocation !== undefined) { 
                localVarFormParams.append('aadRevocation', aadRevocation as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns endorsement key metadata based on specific search parameters.
         * @summary Returns all endorsement keys
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GetKeysRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endorsementKeysSearch: async (xKMSClient?: string, body?: GetKeysRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/endorsementkeys/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates an endorsement key into the keyvault automatically, and returns the public key and other unique identifiers as part of the response.
         * @summary Create Endorsement Key (KEK)
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GenerateKeyRequestDto} [generateKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateEndorsementKey: async (xKMSClient?: string, generateKeyRequestDto?: GenerateKeyRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/generate/kek`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateKeyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EndorsementKeysApi - functional programming interface
 * @export
 */
export const EndorsementKeysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EndorsementKeysApiAxiosParamCreator(configuration)
    return {
        /**
         * Adds a new endorsement key into the keyvault and storage table and return identifiers associated with it.
         * @summary Creates and returns a new endorsement key
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {EndorsementKeyRequestDto} [endorsementKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async endorsementKeyAdd(xKMSClient?: string, endorsementKeyRequestDto?: EndorsementKeyRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.endorsementKeyAdd(xKMSClient, endorsementKeyRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndorsementKeysApi.endorsementKeyAdd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes an endorsement key from storage and keyvault.
         * @summary Deletes a given endorsement key on a specific key id
         * @param {string} keyId The key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async endorsementKeyDelete(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.endorsementKeyDelete(keyId, xKMSClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndorsementKeysApi.endorsementKeyDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns endorsement key metadata excluding the private key.
         * @summary Returns endorsement key metadata for a specific keyId
         * @param {string} keyId The endorsement key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async endorsementKeyGet(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.endorsementKeyGet(keyId, xKMSClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndorsementKeysApi.endorsementKeyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the AADRevocation group and KeyName for a specific endorsement key.
         * @summary Updates an endorsement key based on a specific key id
         * @param {string} keyId The key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {KeyRequestDto} [keyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async endorsementKeyUpdate(keyId: string, xKMSClient?: string, keyRequestDto?: KeyRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.endorsementKeyUpdate(keyId, xKMSClient, keyRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndorsementKeysApi.endorsementKeyUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Uploads a new endorsement key into the keyvault and storage table and return identifiers associated with it.
         * @summary Uploads a new endorsement key
         * @param {string} file The binary file containing the key to be uploaded.
         * @param {string} keyName The Key name.
         * @param {string} aadRevocation Identifier used to validate if the user is authorized to use the key. Not applicable for client credentials flow.
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async endorsementKeyUpload(file: string, keyName: string, aadRevocation: string, xKMSClient?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.endorsementKeyUpload(file, keyName, aadRevocation, xKMSClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndorsementKeysApi.endorsementKeyUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns endorsement key metadata based on specific search parameters.
         * @summary Returns all endorsement keys
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GetKeysRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async endorsementKeysSearch(xKMSClient?: string, body?: GetKeysRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchKeysResponseDtoEndorsementKeyEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.endorsementKeysSearch(xKMSClient, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndorsementKeysApi.endorsementKeysSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates an endorsement key into the keyvault automatically, and returns the public key and other unique identifiers as part of the response.
         * @summary Create Endorsement Key (KEK)
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GenerateKeyRequestDto} [generateKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateEndorsementKey(xKMSClient?: string, generateKeyRequestDto?: GenerateKeyRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateEndorsementKey(xKMSClient, generateKeyRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EndorsementKeysApi.generateEndorsementKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EndorsementKeysApi - factory interface
 * @export
 */
export const EndorsementKeysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EndorsementKeysApiFp(configuration)
    return {
        /**
         * Adds a new endorsement key into the keyvault and storage table and return identifiers associated with it.
         * @summary Creates and returns a new endorsement key
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {EndorsementKeyRequestDto} [endorsementKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endorsementKeyAdd(xKMSClient?: string, endorsementKeyRequestDto?: EndorsementKeyRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<GenericKeyResponseDto> {
            return localVarFp.endorsementKeyAdd(xKMSClient, endorsementKeyRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes an endorsement key from storage and keyvault.
         * @summary Deletes a given endorsement key on a specific key id
         * @param {string} keyId The key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endorsementKeyDelete(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.endorsementKeyDelete(keyId, xKMSClient, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns endorsement key metadata excluding the private key.
         * @summary Returns endorsement key metadata for a specific keyId
         * @param {string} keyId The endorsement key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endorsementKeyGet(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig): AxiosPromise<GenericKeyResponseDto> {
            return localVarFp.endorsementKeyGet(keyId, xKMSClient, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the AADRevocation group and KeyName for a specific endorsement key.
         * @summary Updates an endorsement key based on a specific key id
         * @param {string} keyId The key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {KeyRequestDto} [keyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endorsementKeyUpdate(keyId: string, xKMSClient?: string, keyRequestDto?: KeyRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<GenericKeyResponseDto> {
            return localVarFp.endorsementKeyUpdate(keyId, xKMSClient, keyRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Uploads a new endorsement key into the keyvault and storage table and return identifiers associated with it.
         * @summary Uploads a new endorsement key
         * @param {string} file The binary file containing the key to be uploaded.
         * @param {string} keyName The Key name.
         * @param {string} aadRevocation Identifier used to validate if the user is authorized to use the key. Not applicable for client credentials flow.
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endorsementKeyUpload(file: string, keyName: string, aadRevocation: string, xKMSClient?: string, options?: RawAxiosRequestConfig): AxiosPromise<GenericKeyResponseDto> {
            return localVarFp.endorsementKeyUpload(file, keyName, aadRevocation, xKMSClient, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns endorsement key metadata based on specific search parameters.
         * @summary Returns all endorsement keys
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GetKeysRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endorsementKeysSearch(xKMSClient?: string, body?: GetKeysRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SearchKeysResponseDtoEndorsementKeyEntity> {
            return localVarFp.endorsementKeysSearch(xKMSClient, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates an endorsement key into the keyvault automatically, and returns the public key and other unique identifiers as part of the response.
         * @summary Create Endorsement Key (KEK)
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GenerateKeyRequestDto} [generateKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateEndorsementKey(xKMSClient?: string, generateKeyRequestDto?: GenerateKeyRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<GenerateKeyResponseDto> {
            return localVarFp.generateEndorsementKey(xKMSClient, generateKeyRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EndorsementKeysApi - object-oriented interface
 * @export
 * @class EndorsementKeysApi
 * @extends {BaseAPI}
 */
export class EndorsementKeysApi extends BaseAPI {
    /**
     * Adds a new endorsement key into the keyvault and storage table and return identifiers associated with it.
     * @summary Creates and returns a new endorsement key
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {EndorsementKeyRequestDto} [endorsementKeyRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EndorsementKeysApi
     */
    public endorsementKeyAdd(xKMSClient?: string, endorsementKeyRequestDto?: EndorsementKeyRequestDto, options?: RawAxiosRequestConfig) {
        return EndorsementKeysApiFp(this.configuration).endorsementKeyAdd(xKMSClient, endorsementKeyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes an endorsement key from storage and keyvault.
     * @summary Deletes a given endorsement key on a specific key id
     * @param {string} keyId The key id
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EndorsementKeysApi
     */
    public endorsementKeyDelete(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig) {
        return EndorsementKeysApiFp(this.configuration).endorsementKeyDelete(keyId, xKMSClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns endorsement key metadata excluding the private key.
     * @summary Returns endorsement key metadata for a specific keyId
     * @param {string} keyId The endorsement key id
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EndorsementKeysApi
     */
    public endorsementKeyGet(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig) {
        return EndorsementKeysApiFp(this.configuration).endorsementKeyGet(keyId, xKMSClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the AADRevocation group and KeyName for a specific endorsement key.
     * @summary Updates an endorsement key based on a specific key id
     * @param {string} keyId The key id
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {KeyRequestDto} [keyRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EndorsementKeysApi
     */
    public endorsementKeyUpdate(keyId: string, xKMSClient?: string, keyRequestDto?: KeyRequestDto, options?: RawAxiosRequestConfig) {
        return EndorsementKeysApiFp(this.configuration).endorsementKeyUpdate(keyId, xKMSClient, keyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uploads a new endorsement key into the keyvault and storage table and return identifiers associated with it.
     * @summary Uploads a new endorsement key
     * @param {string} file The binary file containing the key to be uploaded.
     * @param {string} keyName The Key name.
     * @param {string} aadRevocation Identifier used to validate if the user is authorized to use the key. Not applicable for client credentials flow.
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EndorsementKeysApi
     */
    public endorsementKeyUpload(file: string, keyName: string, aadRevocation: string, xKMSClient?: string, options?: RawAxiosRequestConfig) {
        return EndorsementKeysApiFp(this.configuration).endorsementKeyUpload(file, keyName, aadRevocation, xKMSClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns endorsement key metadata based on specific search parameters.
     * @summary Returns all endorsement keys
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {GetKeysRequestDto} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EndorsementKeysApi
     */
    public endorsementKeysSearch(xKMSClient?: string, body?: GetKeysRequestDto, options?: RawAxiosRequestConfig) {
        return EndorsementKeysApiFp(this.configuration).endorsementKeysSearch(xKMSClient, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates an endorsement key into the keyvault automatically, and returns the public key and other unique identifiers as part of the response.
     * @summary Create Endorsement Key (KEK)
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {GenerateKeyRequestDto} [generateKeyRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EndorsementKeysApi
     */
    public generateEndorsementKey(xKMSClient?: string, generateKeyRequestDto?: GenerateKeyRequestDto, options?: RawAxiosRequestConfig) {
        return EndorsementKeysApiFp(this.configuration).generateEndorsementKey(xKMSClient, generateKeyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EntraIDRolesApi - axios parameter creator
 * @export
 */
export const EntraIDRolesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes EntraId Roles based on specific ids
         * @summary Deletes EntraId Roles based on specific ids
         * @param {Array<string>} id A comma-separated list of EntraId Role IDs (GUIDs) to be deleted (e.g., &#x60;1d4f56b8-8d52-4a63-9c1e-53e157045d9f,2a7a3a75-0b34-4e89-85ab-42c7bda4a9a8&#x60;).
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entraIdRolesDelete: async (id: Array<string>, xKMSClient?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('entraIdRolesDelete', 'id', id)
            const localVarPath = `/entraidroles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id) {
                localVarQueryParameter['id'] = id;
            }


    
            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all EntraId Roles
         * @summary Returns all EntraId Roles
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entraIdRolesGet: async (xKMSClient?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/entraidroles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds new or updates existing EntraId Roles and returns a collection of EntraId Roles
         * @summary Adds new or updates existing EntraId Roles and returns a collection of EntraId Roles
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {Array<EntraIdRoleRequestDto>} [entraIdRoleRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entraIdRolesUpsert: async (xKMSClient?: string, entraIdRoleRequestDto?: Array<EntraIdRoleRequestDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/entraidroles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entraIdRoleRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntraIDRolesApi - functional programming interface
 * @export
 */
export const EntraIDRolesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EntraIDRolesApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes EntraId Roles based on specific ids
         * @summary Deletes EntraId Roles based on specific ids
         * @param {Array<string>} id A comma-separated list of EntraId Role IDs (GUIDs) to be deleted (e.g., &#x60;1d4f56b8-8d52-4a63-9c1e-53e157045d9f,2a7a3a75-0b34-4e89-85ab-42c7bda4a9a8&#x60;).
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async entraIdRolesDelete(id: Array<string>, xKMSClient?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.entraIdRolesDelete(id, xKMSClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntraIDRolesApi.entraIdRolesDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all EntraId Roles
         * @summary Returns all EntraId Roles
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async entraIdRolesGet(xKMSClient?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntraIdRoleResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.entraIdRolesGet(xKMSClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntraIDRolesApi.entraIdRolesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Adds new or updates existing EntraId Roles and returns a collection of EntraId Roles
         * @summary Adds new or updates existing EntraId Roles and returns a collection of EntraId Roles
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {Array<EntraIdRoleRequestDto>} [entraIdRoleRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async entraIdRolesUpsert(xKMSClient?: string, entraIdRoleRequestDto?: Array<EntraIdRoleRequestDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntraIdRoleResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.entraIdRolesUpsert(xKMSClient, entraIdRoleRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EntraIDRolesApi.entraIdRolesUpsert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EntraIDRolesApi - factory interface
 * @export
 */
export const EntraIDRolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EntraIDRolesApiFp(configuration)
    return {
        /**
         * Deletes EntraId Roles based on specific ids
         * @summary Deletes EntraId Roles based on specific ids
         * @param {Array<string>} id A comma-separated list of EntraId Role IDs (GUIDs) to be deleted (e.g., &#x60;1d4f56b8-8d52-4a63-9c1e-53e157045d9f,2a7a3a75-0b34-4e89-85ab-42c7bda4a9a8&#x60;).
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entraIdRolesDelete(id: Array<string>, xKMSClient?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.entraIdRolesDelete(id, xKMSClient, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all EntraId Roles
         * @summary Returns all EntraId Roles
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entraIdRolesGet(xKMSClient?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntraIdRoleResponseDto>> {
            return localVarFp.entraIdRolesGet(xKMSClient, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds new or updates existing EntraId Roles and returns a collection of EntraId Roles
         * @summary Adds new or updates existing EntraId Roles and returns a collection of EntraId Roles
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {Array<EntraIdRoleRequestDto>} [entraIdRoleRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entraIdRolesUpsert(xKMSClient?: string, entraIdRoleRequestDto?: Array<EntraIdRoleRequestDto>, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntraIdRoleResponseDto>> {
            return localVarFp.entraIdRolesUpsert(xKMSClient, entraIdRoleRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EntraIDRolesApi - object-oriented interface
 * @export
 * @class EntraIDRolesApi
 * @extends {BaseAPI}
 */
export class EntraIDRolesApi extends BaseAPI {
    /**
     * Deletes EntraId Roles based on specific ids
     * @summary Deletes EntraId Roles based on specific ids
     * @param {Array<string>} id A comma-separated list of EntraId Role IDs (GUIDs) to be deleted (e.g., &#x60;1d4f56b8-8d52-4a63-9c1e-53e157045d9f,2a7a3a75-0b34-4e89-85ab-42c7bda4a9a8&#x60;).
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntraIDRolesApi
     */
    public entraIdRolesDelete(id: Array<string>, xKMSClient?: string, options?: RawAxiosRequestConfig) {
        return EntraIDRolesApiFp(this.configuration).entraIdRolesDelete(id, xKMSClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all EntraId Roles
     * @summary Returns all EntraId Roles
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntraIDRolesApi
     */
    public entraIdRolesGet(xKMSClient?: string, options?: RawAxiosRequestConfig) {
        return EntraIDRolesApiFp(this.configuration).entraIdRolesGet(xKMSClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds new or updates existing EntraId Roles and returns a collection of EntraId Roles
     * @summary Adds new or updates existing EntraId Roles and returns a collection of EntraId Roles
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {Array<EntraIdRoleRequestDto>} [entraIdRoleRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntraIDRolesApi
     */
    public entraIdRolesUpsert(xKMSClient?: string, entraIdRoleRequestDto?: Array<EntraIdRoleRequestDto>, options?: RawAxiosRequestConfig) {
        return EntraIDRolesApiFp(this.configuration).entraIdRolesUpsert(xKMSClient, entraIdRoleRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LocalAccessKeysApi - axios parameter creator
 * @export
 */
export const LocalAccessKeysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Adds a new enrollment key into the keyvault and storage table and return identifiers associated with it.
         * @summary Creates and returns a new enrollment key
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {EnrollmentKeyRequestDto} [enrollmentKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentKeyAdd: async (xKMSClient?: string, enrollmentKeyRequestDto?: EnrollmentKeyRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/uploadkey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(enrollmentKeyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes an enrollment key from storage and keyvault.
         * @summary Deletes a given enrollment key on a specific key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {DeleteKeyRequestDto} [deleteKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentKeyDelete: async (xKMSClient?: string, deleteKeyRequestDto?: DeleteKeyRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/deletekey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteKeyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of enrollment key metadata based on specific search parameters.
         * @summary Get list of LAK metadata
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GetKeysRequestDto} [getKeysRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentKeyGet: async (xKMSClient?: string, getKeysRequestDto?: GetKeysRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/getkeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getKeysRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns an unlock PIN for a device
         * @summary Returns an unlock PIN for a device
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {UnlockPinRequestDto} [unlockPinRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentKeyGetPin: async (xKMSClient?: string, unlockPinRequestDto?: UnlockPinRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/getunlockpin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unlockPinRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the AADRevocation group and KeyName for a specific local access key.
         * @summary Update LAK meta
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {EnrollmentKeyEntityRequestDto} [enrollmentKeyEntityRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentKeyUpdate: async (xKMSClient?: string, enrollmentKeyEntityRequestDto?: EnrollmentKeyEntityRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/updatekeyinfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(enrollmentKeyEntityRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uploads a new enrollment key into the keyvault and storage table and return identifiers associated with it.
         * @summary Uploads a new enrollment key
         * @param {string} file The binary file containing the key to be uploaded.
         * @param {string} keyName The Key name.
         * @param {string} aadRevocation Identifier used to validate if the user is authorized to use the key. Not applicable for client credentials flow.
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentKeyUpload: async (file: string, keyName: string, aadRevocation: string, xKMSClient?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('enrollmentKeyUpload', 'file', file)
            // verify required parameter 'keyName' is not null or undefined
            assertParamExists('enrollmentKeyUpload', 'keyName', keyName)
            // verify required parameter 'aadRevocation' is not null or undefined
            assertParamExists('enrollmentKeyUpload', 'aadRevocation', aadRevocation)
            const localVarPath = `/enrollmentkey-upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (keyName !== undefined) { 
                localVarFormParams.append('keyName', keyName as any);
            }
    
            if (aadRevocation !== undefined) { 
                localVarFormParams.append('aadRevocation', aadRevocation as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a local access key into the keyvault automatically, inserts into the storage table and returns the public key and other unqiue identifiers as part of the response.
         * @summary Create Local Access Key (LAK)
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GenerateKeyRequestDto} [generateKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLocalAccessKey: async (xKMSClient?: string, generateKeyRequestDto?: GenerateKeyRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/generate/lak`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateKeyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocalAccessKeysApi - functional programming interface
 * @export
 */
export const LocalAccessKeysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocalAccessKeysApiAxiosParamCreator(configuration)
    return {
        /**
         * Adds a new enrollment key into the keyvault and storage table and return identifiers associated with it.
         * @summary Creates and returns a new enrollment key
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {EnrollmentKeyRequestDto} [enrollmentKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentKeyAdd(xKMSClient?: string, enrollmentKeyRequestDto?: EnrollmentKeyRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enrollmentKeyAdd(xKMSClient, enrollmentKeyRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocalAccessKeysApi.enrollmentKeyAdd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes an enrollment key from storage and keyvault.
         * @summary Deletes a given enrollment key on a specific key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {DeleteKeyRequestDto} [deleteKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentKeyDelete(xKMSClient?: string, deleteKeyRequestDto?: DeleteKeyRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enrollmentKeyDelete(xKMSClient, deleteKeyRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocalAccessKeysApi.enrollmentKeyDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a list of enrollment key metadata based on specific search parameters.
         * @summary Get list of LAK metadata
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GetKeysRequestDto} [getKeysRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentKeyGet(xKMSClient?: string, getKeysRequestDto?: GetKeysRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KeysResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enrollmentKeyGet(xKMSClient, getKeysRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocalAccessKeysApi.enrollmentKeyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns an unlock PIN for a device
         * @summary Returns an unlock PIN for a device
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {UnlockPinRequestDto} [unlockPinRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentKeyGetPin(xKMSClient?: string, unlockPinRequestDto?: UnlockPinRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enrollmentKeyGetPin(xKMSClient, unlockPinRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocalAccessKeysApi.enrollmentKeyGetPin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the AADRevocation group and KeyName for a specific local access key.
         * @summary Update LAK meta
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {EnrollmentKeyEntityRequestDto} [enrollmentKeyEntityRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentKeyUpdate(xKMSClient?: string, enrollmentKeyEntityRequestDto?: EnrollmentKeyEntityRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KeyEntityResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enrollmentKeyUpdate(xKMSClient, enrollmentKeyEntityRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocalAccessKeysApi.enrollmentKeyUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Uploads a new enrollment key into the keyvault and storage table and return identifiers associated with it.
         * @summary Uploads a new enrollment key
         * @param {string} file The binary file containing the key to be uploaded.
         * @param {string} keyName The Key name.
         * @param {string} aadRevocation Identifier used to validate if the user is authorized to use the key. Not applicable for client credentials flow.
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enrollmentKeyUpload(file: string, keyName: string, aadRevocation: string, xKMSClient?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enrollmentKeyUpload(file, keyName, aadRevocation, xKMSClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocalAccessKeysApi.enrollmentKeyUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a local access key into the keyvault automatically, inserts into the storage table and returns the public key and other unqiue identifiers as part of the response.
         * @summary Create Local Access Key (LAK)
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GenerateKeyRequestDto} [generateKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateLocalAccessKey(xKMSClient?: string, generateKeyRequestDto?: GenerateKeyRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateLocalAccessKey(xKMSClient, generateKeyRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocalAccessKeysApi.generateLocalAccessKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LocalAccessKeysApi - factory interface
 * @export
 */
export const LocalAccessKeysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocalAccessKeysApiFp(configuration)
    return {
        /**
         * Adds a new enrollment key into the keyvault and storage table and return identifiers associated with it.
         * @summary Creates and returns a new enrollment key
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {EnrollmentKeyRequestDto} [enrollmentKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentKeyAdd(xKMSClient?: string, enrollmentKeyRequestDto?: EnrollmentKeyRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<GenericKeyResponseDto> {
            return localVarFp.enrollmentKeyAdd(xKMSClient, enrollmentKeyRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes an enrollment key from storage and keyvault.
         * @summary Deletes a given enrollment key on a specific key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {DeleteKeyRequestDto} [deleteKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentKeyDelete(xKMSClient?: string, deleteKeyRequestDto?: DeleteKeyRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.enrollmentKeyDelete(xKMSClient, deleteKeyRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of enrollment key metadata based on specific search parameters.
         * @summary Get list of LAK metadata
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GetKeysRequestDto} [getKeysRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentKeyGet(xKMSClient?: string, getKeysRequestDto?: GetKeysRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<KeysResponseDto> {
            return localVarFp.enrollmentKeyGet(xKMSClient, getKeysRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns an unlock PIN for a device
         * @summary Returns an unlock PIN for a device
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {UnlockPinRequestDto} [unlockPinRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentKeyGetPin(xKMSClient?: string, unlockPinRequestDto?: UnlockPinRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.enrollmentKeyGetPin(xKMSClient, unlockPinRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the AADRevocation group and KeyName for a specific local access key.
         * @summary Update LAK meta
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {EnrollmentKeyEntityRequestDto} [enrollmentKeyEntityRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentKeyUpdate(xKMSClient?: string, enrollmentKeyEntityRequestDto?: EnrollmentKeyEntityRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<KeyEntityResponseDto> {
            return localVarFp.enrollmentKeyUpdate(xKMSClient, enrollmentKeyEntityRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Uploads a new enrollment key into the keyvault and storage table and return identifiers associated with it.
         * @summary Uploads a new enrollment key
         * @param {string} file The binary file containing the key to be uploaded.
         * @param {string} keyName The Key name.
         * @param {string} aadRevocation Identifier used to validate if the user is authorized to use the key. Not applicable for client credentials flow.
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enrollmentKeyUpload(file: string, keyName: string, aadRevocation: string, xKMSClient?: string, options?: RawAxiosRequestConfig): AxiosPromise<GenericKeyResponseDto> {
            return localVarFp.enrollmentKeyUpload(file, keyName, aadRevocation, xKMSClient, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a local access key into the keyvault automatically, inserts into the storage table and returns the public key and other unqiue identifiers as part of the response.
         * @summary Create Local Access Key (LAK)
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GenerateKeyRequestDto} [generateKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLocalAccessKey(xKMSClient?: string, generateKeyRequestDto?: GenerateKeyRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<GenerateKeyResponseDto> {
            return localVarFp.generateLocalAccessKey(xKMSClient, generateKeyRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocalAccessKeysApi - object-oriented interface
 * @export
 * @class LocalAccessKeysApi
 * @extends {BaseAPI}
 */
export class LocalAccessKeysApi extends BaseAPI {
    /**
     * Adds a new enrollment key into the keyvault and storage table and return identifiers associated with it.
     * @summary Creates and returns a new enrollment key
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {EnrollmentKeyRequestDto} [enrollmentKeyRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocalAccessKeysApi
     */
    public enrollmentKeyAdd(xKMSClient?: string, enrollmentKeyRequestDto?: EnrollmentKeyRequestDto, options?: RawAxiosRequestConfig) {
        return LocalAccessKeysApiFp(this.configuration).enrollmentKeyAdd(xKMSClient, enrollmentKeyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes an enrollment key from storage and keyvault.
     * @summary Deletes a given enrollment key on a specific key id
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {DeleteKeyRequestDto} [deleteKeyRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocalAccessKeysApi
     */
    public enrollmentKeyDelete(xKMSClient?: string, deleteKeyRequestDto?: DeleteKeyRequestDto, options?: RawAxiosRequestConfig) {
        return LocalAccessKeysApiFp(this.configuration).enrollmentKeyDelete(xKMSClient, deleteKeyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of enrollment key metadata based on specific search parameters.
     * @summary Get list of LAK metadata
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {GetKeysRequestDto} [getKeysRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocalAccessKeysApi
     */
    public enrollmentKeyGet(xKMSClient?: string, getKeysRequestDto?: GetKeysRequestDto, options?: RawAxiosRequestConfig) {
        return LocalAccessKeysApiFp(this.configuration).enrollmentKeyGet(xKMSClient, getKeysRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns an unlock PIN for a device
     * @summary Returns an unlock PIN for a device
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {UnlockPinRequestDto} [unlockPinRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocalAccessKeysApi
     */
    public enrollmentKeyGetPin(xKMSClient?: string, unlockPinRequestDto?: UnlockPinRequestDto, options?: RawAxiosRequestConfig) {
        return LocalAccessKeysApiFp(this.configuration).enrollmentKeyGetPin(xKMSClient, unlockPinRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the AADRevocation group and KeyName for a specific local access key.
     * @summary Update LAK meta
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {EnrollmentKeyEntityRequestDto} [enrollmentKeyEntityRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocalAccessKeysApi
     */
    public enrollmentKeyUpdate(xKMSClient?: string, enrollmentKeyEntityRequestDto?: EnrollmentKeyEntityRequestDto, options?: RawAxiosRequestConfig) {
        return LocalAccessKeysApiFp(this.configuration).enrollmentKeyUpdate(xKMSClient, enrollmentKeyEntityRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uploads a new enrollment key into the keyvault and storage table and return identifiers associated with it.
     * @summary Uploads a new enrollment key
     * @param {string} file The binary file containing the key to be uploaded.
     * @param {string} keyName The Key name.
     * @param {string} aadRevocation Identifier used to validate if the user is authorized to use the key. Not applicable for client credentials flow.
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocalAccessKeysApi
     */
    public enrollmentKeyUpload(file: string, keyName: string, aadRevocation: string, xKMSClient?: string, options?: RawAxiosRequestConfig) {
        return LocalAccessKeysApiFp(this.configuration).enrollmentKeyUpload(file, keyName, aadRevocation, xKMSClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a local access key into the keyvault automatically, inserts into the storage table and returns the public key and other unqiue identifiers as part of the response.
     * @summary Create Local Access Key (LAK)
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {GenerateKeyRequestDto} [generateKeyRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocalAccessKeysApi
     */
    public generateLocalAccessKey(xKMSClient?: string, generateKeyRequestDto?: GenerateKeyRequestDto, options?: RawAxiosRequestConfig) {
        return LocalAccessKeysApiFp(this.configuration).generateLocalAccessKey(xKMSClient, generateKeyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RotateKeysApi - axios parameter creator
 * @export
 */
export const RotateKeysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Generates a command to deprovision a device by removing the KEK on the device authorized (signed) using the private portion of that KEK.
         * @summary Deprovision device (Remove KEK)
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {BaseCommandRequestDto} [baseCommandRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprovisionDevice: async (xKMSClient?: string, baseCommandRequestDto?: BaseCommandRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commands/mkh/deprovision-device`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseCommandRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates a command to change to a new KEK, authorized (signed) by the KEK on the existing system without deprovisioning and restarting the device.
         * @summary Rotate KEK
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {RotateKeyRequestDto} [rotateKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rotateEndorsementKey: async (xKMSClient?: string, rotateKeyRequestDto?: RotateKeyRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commands/mkh/updatedevice-kek`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rotateKeyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates a command to change the SK on a device, authorized (signed) by KEK currently on the device.
         * @summary Rotate SK
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {RotateKeyRequestDto} [rotateKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rotateSigningKey: async (xKMSClient?: string, rotateKeyRequestDto?: RotateKeyRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commands/mkh/updatedevice-sk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rotateKeyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RotateKeysApi - functional programming interface
 * @export
 */
export const RotateKeysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RotateKeysApiAxiosParamCreator(configuration)
    return {
        /**
         * Generates a command to deprovision a device by removing the KEK on the device authorized (signed) using the private portion of that KEK.
         * @summary Deprovision device (Remove KEK)
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {BaseCommandRequestDto} [baseCommandRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deprovisionDevice(xKMSClient?: string, baseCommandRequestDto?: BaseCommandRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RotateKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deprovisionDevice(xKMSClient, baseCommandRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RotateKeysApi.deprovisionDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates a command to change to a new KEK, authorized (signed) by the KEK on the existing system without deprovisioning and restarting the device.
         * @summary Rotate KEK
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {RotateKeyRequestDto} [rotateKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rotateEndorsementKey(xKMSClient?: string, rotateKeyRequestDto?: RotateKeyRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RotateKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rotateEndorsementKey(xKMSClient, rotateKeyRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RotateKeysApi.rotateEndorsementKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates a command to change the SK on a device, authorized (signed) by KEK currently on the device.
         * @summary Rotate SK
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {RotateKeyRequestDto} [rotateKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rotateSigningKey(xKMSClient?: string, rotateKeyRequestDto?: RotateKeyRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RotateKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rotateSigningKey(xKMSClient, rotateKeyRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RotateKeysApi.rotateSigningKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RotateKeysApi - factory interface
 * @export
 */
export const RotateKeysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RotateKeysApiFp(configuration)
    return {
        /**
         * Generates a command to deprovision a device by removing the KEK on the device authorized (signed) using the private portion of that KEK.
         * @summary Deprovision device (Remove KEK)
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {BaseCommandRequestDto} [baseCommandRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deprovisionDevice(xKMSClient?: string, baseCommandRequestDto?: BaseCommandRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RotateKeyResponseDto> {
            return localVarFp.deprovisionDevice(xKMSClient, baseCommandRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates a command to change to a new KEK, authorized (signed) by the KEK on the existing system without deprovisioning and restarting the device.
         * @summary Rotate KEK
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {RotateKeyRequestDto} [rotateKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rotateEndorsementKey(xKMSClient?: string, rotateKeyRequestDto?: RotateKeyRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RotateKeyResponseDto> {
            return localVarFp.rotateEndorsementKey(xKMSClient, rotateKeyRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates a command to change the SK on a device, authorized (signed) by KEK currently on the device.
         * @summary Rotate SK
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {RotateKeyRequestDto} [rotateKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rotateSigningKey(xKMSClient?: string, rotateKeyRequestDto?: RotateKeyRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RotateKeyResponseDto> {
            return localVarFp.rotateSigningKey(xKMSClient, rotateKeyRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RotateKeysApi - object-oriented interface
 * @export
 * @class RotateKeysApi
 * @extends {BaseAPI}
 */
export class RotateKeysApi extends BaseAPI {
    /**
     * Generates a command to deprovision a device by removing the KEK on the device authorized (signed) using the private portion of that KEK.
     * @summary Deprovision device (Remove KEK)
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {BaseCommandRequestDto} [baseCommandRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RotateKeysApi
     */
    public deprovisionDevice(xKMSClient?: string, baseCommandRequestDto?: BaseCommandRequestDto, options?: RawAxiosRequestConfig) {
        return RotateKeysApiFp(this.configuration).deprovisionDevice(xKMSClient, baseCommandRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates a command to change to a new KEK, authorized (signed) by the KEK on the existing system without deprovisioning and restarting the device.
     * @summary Rotate KEK
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {RotateKeyRequestDto} [rotateKeyRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RotateKeysApi
     */
    public rotateEndorsementKey(xKMSClient?: string, rotateKeyRequestDto?: RotateKeyRequestDto, options?: RawAxiosRequestConfig) {
        return RotateKeysApiFp(this.configuration).rotateEndorsementKey(xKMSClient, rotateKeyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates a command to change the SK on a device, authorized (signed) by KEK currently on the device.
     * @summary Rotate SK
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {RotateKeyRequestDto} [rotateKeyRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RotateKeysApi
     */
    public rotateSigningKey(xKMSClient?: string, rotateKeyRequestDto?: RotateKeyRequestDto, options?: RawAxiosRequestConfig) {
        return RotateKeysApiFp(this.configuration).rotateSigningKey(xKMSClient, rotateKeyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SecretsApi - axios parameter creator
 * @export
 */
export const SecretsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates and returns a new secret
         * @summary Creates and returns a new secret
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {AddSecretRequestDto} [addSecretRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        secretAdd: async (xKMSClient?: string, addSecretRequestDto?: AddSecretRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/secrets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addSecretRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a secret based on a specific id
         * @summary Deletes a secret based on a specific id
         * @param {string} id Secret Id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        secretDelete: async (id: string, xKMSClient?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('secretDelete', 'id', id)
            const localVarPath = `/secrets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a non expired secret value based on a specific id
         * @summary Gets a non expired secret value based on a specific id
         * @param {string} id Secret Id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        secretGet: async (id: string, xKMSClient?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('secretGet', 'id', id)
            const localVarPath = `/secrets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all non expired secrets based on secret type
         * @summary Returns all non expired secrets based on secret type
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {SearchSecretsRequestDto} [searchSecretsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        secretSearch: async (xKMSClient?: string, searchSecretsRequestDto?: SearchSecretsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/secrets/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchSecretsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SecretsApi - functional programming interface
 * @export
 */
export const SecretsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SecretsApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates and returns a new secret
         * @summary Creates and returns a new secret
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {AddSecretRequestDto} [addSecretRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async secretAdd(xKMSClient?: string, addSecretRequestDto?: AddSecretRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecretResponseMetadataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.secretAdd(xKMSClient, addSecretRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SecretsApi.secretAdd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a secret based on a specific id
         * @summary Deletes a secret based on a specific id
         * @param {string} id Secret Id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async secretDelete(id: string, xKMSClient?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.secretDelete(id, xKMSClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SecretsApi.secretDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets a non expired secret value based on a specific id
         * @summary Gets a non expired secret value based on a specific id
         * @param {string} id Secret Id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async secretGet(id: string, xKMSClient?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecretResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.secretGet(id, xKMSClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SecretsApi.secretGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all non expired secrets based on secret type
         * @summary Returns all non expired secrets based on secret type
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {SearchSecretsRequestDto} [searchSecretsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async secretSearch(xKMSClient?: string, searchSecretsRequestDto?: SearchSecretsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchSecretsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.secretSearch(xKMSClient, searchSecretsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SecretsApi.secretSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SecretsApi - factory interface
 * @export
 */
export const SecretsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SecretsApiFp(configuration)
    return {
        /**
         * Creates and returns a new secret
         * @summary Creates and returns a new secret
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {AddSecretRequestDto} [addSecretRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        secretAdd(xKMSClient?: string, addSecretRequestDto?: AddSecretRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SecretResponseMetadataDto> {
            return localVarFp.secretAdd(xKMSClient, addSecretRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a secret based on a specific id
         * @summary Deletes a secret based on a specific id
         * @param {string} id Secret Id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        secretDelete(id: string, xKMSClient?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.secretDelete(id, xKMSClient, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a non expired secret value based on a specific id
         * @summary Gets a non expired secret value based on a specific id
         * @param {string} id Secret Id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        secretGet(id: string, xKMSClient?: string, options?: RawAxiosRequestConfig): AxiosPromise<SecretResponseDto> {
            return localVarFp.secretGet(id, xKMSClient, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all non expired secrets based on secret type
         * @summary Returns all non expired secrets based on secret type
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {SearchSecretsRequestDto} [searchSecretsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        secretSearch(xKMSClient?: string, searchSecretsRequestDto?: SearchSecretsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SearchSecretsResponseDto> {
            return localVarFp.secretSearch(xKMSClient, searchSecretsRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SecretsApi - object-oriented interface
 * @export
 * @class SecretsApi
 * @extends {BaseAPI}
 */
export class SecretsApi extends BaseAPI {
    /**
     * Creates and returns a new secret
     * @summary Creates and returns a new secret
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {AddSecretRequestDto} [addSecretRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecretsApi
     */
    public secretAdd(xKMSClient?: string, addSecretRequestDto?: AddSecretRequestDto, options?: RawAxiosRequestConfig) {
        return SecretsApiFp(this.configuration).secretAdd(xKMSClient, addSecretRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a secret based on a specific id
     * @summary Deletes a secret based on a specific id
     * @param {string} id Secret Id
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecretsApi
     */
    public secretDelete(id: string, xKMSClient?: string, options?: RawAxiosRequestConfig) {
        return SecretsApiFp(this.configuration).secretDelete(id, xKMSClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a non expired secret value based on a specific id
     * @summary Gets a non expired secret value based on a specific id
     * @param {string} id Secret Id
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecretsApi
     */
    public secretGet(id: string, xKMSClient?: string, options?: RawAxiosRequestConfig) {
        return SecretsApiFp(this.configuration).secretGet(id, xKMSClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all non expired secrets based on secret type
     * @summary Returns all non expired secrets based on secret type
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {SearchSecretsRequestDto} [searchSecretsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecretsApi
     */
    public secretSearch(xKMSClient?: string, searchSecretsRequestDto?: SearchSecretsRequestDto, options?: RawAxiosRequestConfig) {
        return SecretsApiFp(this.configuration).secretSearch(xKMSClient, searchSecretsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SigningKeysApi - axios parameter creator
 * @export
 */
export const SigningKeysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Generates a keyvault key, inserts metadata into a storage table and returns public key and other unique identifiers.
         * @summary Generate a new Signing Key (SK)
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GenerateKeyRequestDto} [generateKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSigningKey: async (xKMSClient?: string, generateKeyRequestDto?: GenerateKeyRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/generate/sk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateKeyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds a new signing keypair into the Key Management Solution (KMS) and return relevant identifiers associated with it.
         * @summary Creates and returns a new signing key
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {SigningKeyRequestDto} [signingKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signingKeyAdd: async (xKMSClient?: string, signingKeyRequestDto?: SigningKeyRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/signingkeys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signingKeyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes an signing key from storage and keyvault
         * @summary Deletes a given signing key on a specific key id
         * @param {string} keyId The key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signingKeyDelete: async (keyId: string, xKMSClient?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('signingKeyDelete', 'keyId', keyId)
            const localVarPath = `/signingkeys/{keyId}`
                .replace(`{${"keyId"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns signing key metadata excluding the private key.
         * @summary Returns signing key metadata for a specific keyId
         * @param {string} keyId The signing key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signingKeyGet: async (keyId: string, xKMSClient?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('signingKeyGet', 'keyId', keyId)
            const localVarPath = `/signingkeys/{keyId}`
                .replace(`{${"keyId"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the AADRevocation group and KeyName for a specific signing key.
         * @summary Update Signing key meta
         * @param {string} keyId The key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {KeyRequestDto} [keyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signingKeyUpdate: async (keyId: string, xKMSClient?: string, keyRequestDto?: KeyRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('signingKeyUpdate', 'keyId', keyId)
            const localVarPath = `/signingkeys/{keyId}`
                .replace(`{${"keyId"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(keyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload a new signing keypair into the Key Management Solution (KMS) and return relevant identifiers associated with it.
         * @summary Upload a new signing key
         * @param {string} file The binary file containing the key to be uploaded.
         * @param {string} keyName The Key name.
         * @param {string} aadRevocation Identifier used to validate if the user is authorized to use the key. Not applicable for client credentials flow.
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signingKeyUpload: async (file: string, keyName: string, aadRevocation: string, xKMSClient?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('signingKeyUpload', 'file', file)
            // verify required parameter 'keyName' is not null or undefined
            assertParamExists('signingKeyUpload', 'keyName', keyName)
            // verify required parameter 'aadRevocation' is not null or undefined
            assertParamExists('signingKeyUpload', 'aadRevocation', aadRevocation)
            const localVarPath = `/signingkeys-upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (keyName !== undefined) { 
                localVarFormParams.append('keyName', keyName as any);
            }
    
            if (aadRevocation !== undefined) { 
                localVarFormParams.append('aadRevocation', aadRevocation as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return signing key metadata based on specific search parameters.
         * @summary Returns all signing keys
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GetKeysRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signingKeysSearch: async (xKMSClient?: string, body?: GetKeysRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/signingkeys/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SigningKeysApi - functional programming interface
 * @export
 */
export const SigningKeysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SigningKeysApiAxiosParamCreator(configuration)
    return {
        /**
         * Generates a keyvault key, inserts metadata into a storage table and returns public key and other unique identifiers.
         * @summary Generate a new Signing Key (SK)
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GenerateKeyRequestDto} [generateKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateSigningKey(xKMSClient?: string, generateKeyRequestDto?: GenerateKeyRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateSigningKey(xKMSClient, generateKeyRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SigningKeysApi.generateSigningKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Adds a new signing keypair into the Key Management Solution (KMS) and return relevant identifiers associated with it.
         * @summary Creates and returns a new signing key
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {SigningKeyRequestDto} [signingKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signingKeyAdd(xKMSClient?: string, signingKeyRequestDto?: SigningKeyRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signingKeyAdd(xKMSClient, signingKeyRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SigningKeysApi.signingKeyAdd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes an signing key from storage and keyvault
         * @summary Deletes a given signing key on a specific key id
         * @param {string} keyId The key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signingKeyDelete(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signingKeyDelete(keyId, xKMSClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SigningKeysApi.signingKeyDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns signing key metadata excluding the private key.
         * @summary Returns signing key metadata for a specific keyId
         * @param {string} keyId The signing key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signingKeyGet(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signingKeyGet(keyId, xKMSClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SigningKeysApi.signingKeyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the AADRevocation group and KeyName for a specific signing key.
         * @summary Update Signing key meta
         * @param {string} keyId The key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {KeyRequestDto} [keyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signingKeyUpdate(keyId: string, xKMSClient?: string, keyRequestDto?: KeyRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signingKeyUpdate(keyId, xKMSClient, keyRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SigningKeysApi.signingKeyUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload a new signing keypair into the Key Management Solution (KMS) and return relevant identifiers associated with it.
         * @summary Upload a new signing key
         * @param {string} file The binary file containing the key to be uploaded.
         * @param {string} keyName The Key name.
         * @param {string} aadRevocation Identifier used to validate if the user is authorized to use the key. Not applicable for client credentials flow.
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signingKeyUpload(file: string, keyName: string, aadRevocation: string, xKMSClient?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signingKeyUpload(file, keyName, aadRevocation, xKMSClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SigningKeysApi.signingKeyUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return signing key metadata based on specific search parameters.
         * @summary Returns all signing keys
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GetKeysRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signingKeysSearch(xKMSClient?: string, body?: GetKeysRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchKeysResponseDtoSigningKeyEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signingKeysSearch(xKMSClient, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SigningKeysApi.signingKeysSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SigningKeysApi - factory interface
 * @export
 */
export const SigningKeysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SigningKeysApiFp(configuration)
    return {
        /**
         * Generates a keyvault key, inserts metadata into a storage table and returns public key and other unique identifiers.
         * @summary Generate a new Signing Key (SK)
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GenerateKeyRequestDto} [generateKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateSigningKey(xKMSClient?: string, generateKeyRequestDto?: GenerateKeyRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<GenerateKeyResponseDto> {
            return localVarFp.generateSigningKey(xKMSClient, generateKeyRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds a new signing keypair into the Key Management Solution (KMS) and return relevant identifiers associated with it.
         * @summary Creates and returns a new signing key
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {SigningKeyRequestDto} [signingKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signingKeyAdd(xKMSClient?: string, signingKeyRequestDto?: SigningKeyRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<GenericKeyResponseDto> {
            return localVarFp.signingKeyAdd(xKMSClient, signingKeyRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes an signing key from storage and keyvault
         * @summary Deletes a given signing key on a specific key id
         * @param {string} keyId The key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signingKeyDelete(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.signingKeyDelete(keyId, xKMSClient, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns signing key metadata excluding the private key.
         * @summary Returns signing key metadata for a specific keyId
         * @param {string} keyId The signing key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signingKeyGet(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig): AxiosPromise<GenericKeyResponseDto> {
            return localVarFp.signingKeyGet(keyId, xKMSClient, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the AADRevocation group and KeyName for a specific signing key.
         * @summary Update Signing key meta
         * @param {string} keyId The key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {KeyRequestDto} [keyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signingKeyUpdate(keyId: string, xKMSClient?: string, keyRequestDto?: KeyRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<GenericKeyResponseDto> {
            return localVarFp.signingKeyUpdate(keyId, xKMSClient, keyRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload a new signing keypair into the Key Management Solution (KMS) and return relevant identifiers associated with it.
         * @summary Upload a new signing key
         * @param {string} file The binary file containing the key to be uploaded.
         * @param {string} keyName The Key name.
         * @param {string} aadRevocation Identifier used to validate if the user is authorized to use the key. Not applicable for client credentials flow.
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signingKeyUpload(file: string, keyName: string, aadRevocation: string, xKMSClient?: string, options?: RawAxiosRequestConfig): AxiosPromise<GenericKeyResponseDto> {
            return localVarFp.signingKeyUpload(file, keyName, aadRevocation, xKMSClient, options).then((request) => request(axios, basePath));
        },
        /**
         * Return signing key metadata based on specific search parameters.
         * @summary Returns all signing keys
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GetKeysRequestDto} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signingKeysSearch(xKMSClient?: string, body?: GetKeysRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SearchKeysResponseDtoSigningKeyEntity> {
            return localVarFp.signingKeysSearch(xKMSClient, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SigningKeysApi - object-oriented interface
 * @export
 * @class SigningKeysApi
 * @extends {BaseAPI}
 */
export class SigningKeysApi extends BaseAPI {
    /**
     * Generates a keyvault key, inserts metadata into a storage table and returns public key and other unique identifiers.
     * @summary Generate a new Signing Key (SK)
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {GenerateKeyRequestDto} [generateKeyRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SigningKeysApi
     */
    public generateSigningKey(xKMSClient?: string, generateKeyRequestDto?: GenerateKeyRequestDto, options?: RawAxiosRequestConfig) {
        return SigningKeysApiFp(this.configuration).generateSigningKey(xKMSClient, generateKeyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds a new signing keypair into the Key Management Solution (KMS) and return relevant identifiers associated with it.
     * @summary Creates and returns a new signing key
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {SigningKeyRequestDto} [signingKeyRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SigningKeysApi
     */
    public signingKeyAdd(xKMSClient?: string, signingKeyRequestDto?: SigningKeyRequestDto, options?: RawAxiosRequestConfig) {
        return SigningKeysApiFp(this.configuration).signingKeyAdd(xKMSClient, signingKeyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes an signing key from storage and keyvault
     * @summary Deletes a given signing key on a specific key id
     * @param {string} keyId The key id
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SigningKeysApi
     */
    public signingKeyDelete(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig) {
        return SigningKeysApiFp(this.configuration).signingKeyDelete(keyId, xKMSClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns signing key metadata excluding the private key.
     * @summary Returns signing key metadata for a specific keyId
     * @param {string} keyId The signing key id
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SigningKeysApi
     */
    public signingKeyGet(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig) {
        return SigningKeysApiFp(this.configuration).signingKeyGet(keyId, xKMSClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the AADRevocation group and KeyName for a specific signing key.
     * @summary Update Signing key meta
     * @param {string} keyId The key id
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {KeyRequestDto} [keyRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SigningKeysApi
     */
    public signingKeyUpdate(keyId: string, xKMSClient?: string, keyRequestDto?: KeyRequestDto, options?: RawAxiosRequestConfig) {
        return SigningKeysApiFp(this.configuration).signingKeyUpdate(keyId, xKMSClient, keyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload a new signing keypair into the Key Management Solution (KMS) and return relevant identifiers associated with it.
     * @summary Upload a new signing key
     * @param {string} file The binary file containing the key to be uploaded.
     * @param {string} keyName The Key name.
     * @param {string} aadRevocation Identifier used to validate if the user is authorized to use the key. Not applicable for client credentials flow.
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SigningKeysApi
     */
    public signingKeyUpload(file: string, keyName: string, aadRevocation: string, xKMSClient?: string, options?: RawAxiosRequestConfig) {
        return SigningKeysApiFp(this.configuration).signingKeyUpload(file, keyName, aadRevocation, xKMSClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return signing key metadata based on specific search parameters.
     * @summary Returns all signing keys
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {GetKeysRequestDto} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SigningKeysApi
     */
    public signingKeysSearch(xKMSClient?: string, body?: GetKeysRequestDto, options?: RawAxiosRequestConfig) {
        return SigningKeysApiFp(this.configuration).signingKeysSearch(xKMSClient, body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SupervisorKeysApi - axios parameter creator
 * @export
 */
export const SupervisorKeysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes a supervisor key from the Key Management Solution (KMS)
         * @summary Deletes a supervisor key based on a specific id
         * @param {string} keyId The supervisor key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisorKeyDelete: async (keyId: string, xKMSClient?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('supervisorKeyDelete', 'keyId', keyId)
            const localVarPath = `/supervisorkeys/{keyId}`
                .replace(`{${"keyId"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates and returns a new supervisor key.
         * @summary Generates and returns a new supervisor key
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GenerateKeyRequestDto} [generateKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisorKeyGenerate: async (xKMSClient?: string, generateKeyRequestDto?: GenerateKeyRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/generate/supervisorkey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateKeyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a supervisor key metadata excluding the private key.
         * @summary Returns a supervisor key based on a specific id
         * @param {string} keyId The supervisor key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisorKeyGet: async (keyId: string, xKMSClient?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('supervisorKeyGet', 'keyId', keyId)
            const localVarPath = `/supervisorkeys/{keyId}`
                .replace(`{${"keyId"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the AADRevocation group and KeyName for a specific supervisor key.
         * @summary Updates a supervisor key based on a specific id
         * @param {string} keyId The supervisor key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {KeyRequestDto} [keyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisorKeyUpdate: async (keyId: string, xKMSClient?: string, keyRequestDto?: KeyRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('supervisorKeyUpdate', 'keyId', keyId)
            const localVarPath = `/supervisorkeys/{keyId}`
                .replace(`{${"keyId"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(keyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupervisorKeysApi - functional programming interface
 * @export
 */
export const SupervisorKeysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupervisorKeysApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes a supervisor key from the Key Management Solution (KMS)
         * @summary Deletes a supervisor key based on a specific id
         * @param {string} keyId The supervisor key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supervisorKeyDelete(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supervisorKeyDelete(keyId, xKMSClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupervisorKeysApi.supervisorKeyDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates and returns a new supervisor key.
         * @summary Generates and returns a new supervisor key
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GenerateKeyRequestDto} [generateKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supervisorKeyGenerate(xKMSClient?: string, generateKeyRequestDto?: GenerateKeyRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supervisorKeyGenerate(xKMSClient, generateKeyRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupervisorKeysApi.supervisorKeyGenerate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a supervisor key metadata excluding the private key.
         * @summary Returns a supervisor key based on a specific id
         * @param {string} keyId The supervisor key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supervisorKeyGet(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supervisorKeyGet(keyId, xKMSClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupervisorKeysApi.supervisorKeyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the AADRevocation group and KeyName for a specific supervisor key.
         * @summary Updates a supervisor key based on a specific id
         * @param {string} keyId The supervisor key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {KeyRequestDto} [keyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async supervisorKeyUpdate(keyId: string, xKMSClient?: string, keyRequestDto?: KeyRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.supervisorKeyUpdate(keyId, xKMSClient, keyRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SupervisorKeysApi.supervisorKeyUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SupervisorKeysApi - factory interface
 * @export
 */
export const SupervisorKeysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupervisorKeysApiFp(configuration)
    return {
        /**
         * Deletes a supervisor key from the Key Management Solution (KMS)
         * @summary Deletes a supervisor key based on a specific id
         * @param {string} keyId The supervisor key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisorKeyDelete(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.supervisorKeyDelete(keyId, xKMSClient, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates and returns a new supervisor key.
         * @summary Generates and returns a new supervisor key
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GenerateKeyRequestDto} [generateKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisorKeyGenerate(xKMSClient?: string, generateKeyRequestDto?: GenerateKeyRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<GenerateKeyResponseDto> {
            return localVarFp.supervisorKeyGenerate(xKMSClient, generateKeyRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a supervisor key metadata excluding the private key.
         * @summary Returns a supervisor key based on a specific id
         * @param {string} keyId The supervisor key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisorKeyGet(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig): AxiosPromise<GenericKeyResponseDto> {
            return localVarFp.supervisorKeyGet(keyId, xKMSClient, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the AADRevocation group and KeyName for a specific supervisor key.
         * @summary Updates a supervisor key based on a specific id
         * @param {string} keyId The supervisor key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {KeyRequestDto} [keyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        supervisorKeyUpdate(keyId: string, xKMSClient?: string, keyRequestDto?: KeyRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<GenericKeyResponseDto> {
            return localVarFp.supervisorKeyUpdate(keyId, xKMSClient, keyRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupervisorKeysApi - object-oriented interface
 * @export
 * @class SupervisorKeysApi
 * @extends {BaseAPI}
 */
export class SupervisorKeysApi extends BaseAPI {
    /**
     * Deletes a supervisor key from the Key Management Solution (KMS)
     * @summary Deletes a supervisor key based on a specific id
     * @param {string} keyId The supervisor key id
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupervisorKeysApi
     */
    public supervisorKeyDelete(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig) {
        return SupervisorKeysApiFp(this.configuration).supervisorKeyDelete(keyId, xKMSClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates and returns a new supervisor key.
     * @summary Generates and returns a new supervisor key
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {GenerateKeyRequestDto} [generateKeyRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupervisorKeysApi
     */
    public supervisorKeyGenerate(xKMSClient?: string, generateKeyRequestDto?: GenerateKeyRequestDto, options?: RawAxiosRequestConfig) {
        return SupervisorKeysApiFp(this.configuration).supervisorKeyGenerate(xKMSClient, generateKeyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a supervisor key metadata excluding the private key.
     * @summary Returns a supervisor key based on a specific id
     * @param {string} keyId The supervisor key id
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupervisorKeysApi
     */
    public supervisorKeyGet(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig) {
        return SupervisorKeysApiFp(this.configuration).supervisorKeyGet(keyId, xKMSClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the AADRevocation group and KeyName for a specific supervisor key.
     * @summary Updates a supervisor key based on a specific id
     * @param {string} keyId The supervisor key id
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {KeyRequestDto} [keyRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupervisorKeysApi
     */
    public supervisorKeyUpdate(keyId: string, xKMSClient?: string, keyRequestDto?: KeyRequestDto, options?: RawAxiosRequestConfig) {
        return SupervisorKeysApiFp(this.configuration).supervisorKeyUpdate(keyId, xKMSClient, keyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TenantKeysApi - axios parameter creator
 * @export
 */
export const TenantKeysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes a tenant key from the Key Management Solution (KMS)
         * @summary Deletes a tenant key based on a specific id
         * @param {string} keyId The tenant key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantKeyDelete: async (keyId: string, xKMSClient?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('tenantKeyDelete', 'keyId', keyId)
            const localVarPath = `/tenantkeys/{keyId}`
                .replace(`{${"keyId"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates and returns a new tenant key.
         * @summary Generates and returns a new tenant key
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GenerateKeyRequestDto} [generateKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantKeyGenerate: async (xKMSClient?: string, generateKeyRequestDto?: GenerateKeyRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/generate/tenantkey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateKeyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a tenant key metadata excluding the private key.
         * @summary Returns a tenant key based on a specific id
         * @param {string} keyId The tenant key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantKeyGet: async (keyId: string, xKMSClient?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('tenantKeyGet', 'keyId', keyId)
            const localVarPath = `/tenantkeys/{keyId}`
                .replace(`{${"keyId"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the AADRevocation group and KeyName for a specific tenant key.
         * @summary Updates a tenant key based on a specific id
         * @param {string} keyId The tenant key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {KeyRequestDto} [keyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantKeyUpdate: async (keyId: string, xKMSClient?: string, keyRequestDto?: KeyRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('tenantKeyUpdate', 'keyId', keyId)
            const localVarPath = `/tenantkeys/{keyId}`
                .replace(`{${"keyId"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(keyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantKeysApi - functional programming interface
 * @export
 */
export const TenantKeysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TenantKeysApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes a tenant key from the Key Management Solution (KMS)
         * @summary Deletes a tenant key based on a specific id
         * @param {string} keyId The tenant key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantKeyDelete(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantKeyDelete(keyId, xKMSClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantKeysApi.tenantKeyDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates and returns a new tenant key.
         * @summary Generates and returns a new tenant key
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GenerateKeyRequestDto} [generateKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantKeyGenerate(xKMSClient?: string, generateKeyRequestDto?: GenerateKeyRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantKeyGenerate(xKMSClient, generateKeyRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantKeysApi.tenantKeyGenerate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a tenant key metadata excluding the private key.
         * @summary Returns a tenant key based on a specific id
         * @param {string} keyId The tenant key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantKeyGet(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantKeyGet(keyId, xKMSClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantKeysApi.tenantKeyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the AADRevocation group and KeyName for a specific tenant key.
         * @summary Updates a tenant key based on a specific id
         * @param {string} keyId The tenant key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {KeyRequestDto} [keyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantKeyUpdate(keyId: string, xKMSClient?: string, keyRequestDto?: KeyRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tenantKeyUpdate(keyId, xKMSClient, keyRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TenantKeysApi.tenantKeyUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TenantKeysApi - factory interface
 * @export
 */
export const TenantKeysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TenantKeysApiFp(configuration)
    return {
        /**
         * Deletes a tenant key from the Key Management Solution (KMS)
         * @summary Deletes a tenant key based on a specific id
         * @param {string} keyId The tenant key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantKeyDelete(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.tenantKeyDelete(keyId, xKMSClient, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates and returns a new tenant key.
         * @summary Generates and returns a new tenant key
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GenerateKeyRequestDto} [generateKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantKeyGenerate(xKMSClient?: string, generateKeyRequestDto?: GenerateKeyRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<GenerateKeyResponseDto> {
            return localVarFp.tenantKeyGenerate(xKMSClient, generateKeyRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a tenant key metadata excluding the private key.
         * @summary Returns a tenant key based on a specific id
         * @param {string} keyId The tenant key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantKeyGet(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig): AxiosPromise<GenericKeyResponseDto> {
            return localVarFp.tenantKeyGet(keyId, xKMSClient, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the AADRevocation group and KeyName for a specific tenant key.
         * @summary Updates a tenant key based on a specific id
         * @param {string} keyId The tenant key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {KeyRequestDto} [keyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantKeyUpdate(keyId: string, xKMSClient?: string, keyRequestDto?: KeyRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<GenericKeyResponseDto> {
            return localVarFp.tenantKeyUpdate(keyId, xKMSClient, keyRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TenantKeysApi - object-oriented interface
 * @export
 * @class TenantKeysApi
 * @extends {BaseAPI}
 */
export class TenantKeysApi extends BaseAPI {
    /**
     * Deletes a tenant key from the Key Management Solution (KMS)
     * @summary Deletes a tenant key based on a specific id
     * @param {string} keyId The tenant key id
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantKeysApi
     */
    public tenantKeyDelete(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig) {
        return TenantKeysApiFp(this.configuration).tenantKeyDelete(keyId, xKMSClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates and returns a new tenant key.
     * @summary Generates and returns a new tenant key
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {GenerateKeyRequestDto} [generateKeyRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantKeysApi
     */
    public tenantKeyGenerate(xKMSClient?: string, generateKeyRequestDto?: GenerateKeyRequestDto, options?: RawAxiosRequestConfig) {
        return TenantKeysApiFp(this.configuration).tenantKeyGenerate(xKMSClient, generateKeyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a tenant key metadata excluding the private key.
     * @summary Returns a tenant key based on a specific id
     * @param {string} keyId The tenant key id
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantKeysApi
     */
    public tenantKeyGet(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig) {
        return TenantKeysApiFp(this.configuration).tenantKeyGet(keyId, xKMSClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the AADRevocation group and KeyName for a specific tenant key.
     * @summary Updates a tenant key based on a specific id
     * @param {string} keyId The tenant key id
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {KeyRequestDto} [keyRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantKeysApi
     */
    public tenantKeyUpdate(keyId: string, xKMSClient?: string, keyRequestDto?: KeyRequestDto, options?: RawAxiosRequestConfig) {
        return TenantKeysApiFp(this.configuration).tenantKeyUpdate(keyId, xKMSClient, keyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ThresholdKeysApi - axios parameter creator
 * @export
 */
export const ThresholdKeysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes a threshold key from the Key Management Solution (KMS)
         * @summary Deletes a threshold key based on a specific id
         * @param {string} keyId The threshold key entity id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thresholdKeyDelete: async (keyId: string, xKMSClient?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('thresholdKeyDelete', 'keyId', keyId)
            const localVarPath = `/thresholdkeys/{keyId}`
                .replace(`{${"keyId"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates and returns a new threshold key
         * @summary Generates and returns a new threshold key
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GenerateKeyRequestDto} [generateKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thresholdKeyGenerate: async (xKMSClient?: string, generateKeyRequestDto?: GenerateKeyRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/generate/thresholdkey`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateKeyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a threshold key metadata excluding the private key.
         * @summary Returns a threshold key based on a specific id
         * @param {string} keyId The threshold key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thresholdKeyGet: async (keyId: string, xKMSClient?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('thresholdKeyGet', 'keyId', keyId)
            const localVarPath = `/thresholdkeys/{keyId}`
                .replace(`{${"keyId"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the AADRevocation group and KeyName for a specific threshold key.
         * @summary Updates a threshold key based on a specific id
         * @param {string} keyId The threshold key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {KeyRequestDto} [keyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thresholdKeyUpdate: async (keyId: string, xKMSClient?: string, keyRequestDto?: KeyRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyId' is not null or undefined
            assertParamExists('thresholdKeyUpdate', 'keyId', keyId)
            const localVarPath = `/thresholdkeys/{keyId}`
                .replace(`{${"keyId"}}`, encodeURIComponent(String(keyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(keyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ThresholdKeysApi - functional programming interface
 * @export
 */
export const ThresholdKeysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ThresholdKeysApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes a threshold key from the Key Management Solution (KMS)
         * @summary Deletes a threshold key based on a specific id
         * @param {string} keyId The threshold key entity id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async thresholdKeyDelete(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.thresholdKeyDelete(keyId, xKMSClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThresholdKeysApi.thresholdKeyDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates and returns a new threshold key
         * @summary Generates and returns a new threshold key
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GenerateKeyRequestDto} [generateKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async thresholdKeyGenerate(xKMSClient?: string, generateKeyRequestDto?: GenerateKeyRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.thresholdKeyGenerate(xKMSClient, generateKeyRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThresholdKeysApi.thresholdKeyGenerate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a threshold key metadata excluding the private key.
         * @summary Returns a threshold key based on a specific id
         * @param {string} keyId The threshold key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async thresholdKeyGet(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.thresholdKeyGet(keyId, xKMSClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThresholdKeysApi.thresholdKeyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the AADRevocation group and KeyName for a specific threshold key.
         * @summary Updates a threshold key based on a specific id
         * @param {string} keyId The threshold key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {KeyRequestDto} [keyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async thresholdKeyUpdate(keyId: string, xKMSClient?: string, keyRequestDto?: KeyRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenericKeyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.thresholdKeyUpdate(keyId, xKMSClient, keyRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThresholdKeysApi.thresholdKeyUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ThresholdKeysApi - factory interface
 * @export
 */
export const ThresholdKeysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ThresholdKeysApiFp(configuration)
    return {
        /**
         * Deletes a threshold key from the Key Management Solution (KMS)
         * @summary Deletes a threshold key based on a specific id
         * @param {string} keyId The threshold key entity id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thresholdKeyDelete(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.thresholdKeyDelete(keyId, xKMSClient, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates and returns a new threshold key
         * @summary Generates and returns a new threshold key
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {GenerateKeyRequestDto} [generateKeyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thresholdKeyGenerate(xKMSClient?: string, generateKeyRequestDto?: GenerateKeyRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<GenerateKeyResponseDto> {
            return localVarFp.thresholdKeyGenerate(xKMSClient, generateKeyRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a threshold key metadata excluding the private key.
         * @summary Returns a threshold key based on a specific id
         * @param {string} keyId The threshold key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thresholdKeyGet(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig): AxiosPromise<GenericKeyResponseDto> {
            return localVarFp.thresholdKeyGet(keyId, xKMSClient, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the AADRevocation group and KeyName for a specific threshold key.
         * @summary Updates a threshold key based on a specific id
         * @param {string} keyId The threshold key id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {KeyRequestDto} [keyRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thresholdKeyUpdate(keyId: string, xKMSClient?: string, keyRequestDto?: KeyRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<GenericKeyResponseDto> {
            return localVarFp.thresholdKeyUpdate(keyId, xKMSClient, keyRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ThresholdKeysApi - object-oriented interface
 * @export
 * @class ThresholdKeysApi
 * @extends {BaseAPI}
 */
export class ThresholdKeysApi extends BaseAPI {
    /**
     * Deletes a threshold key from the Key Management Solution (KMS)
     * @summary Deletes a threshold key based on a specific id
     * @param {string} keyId The threshold key entity id
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThresholdKeysApi
     */
    public thresholdKeyDelete(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig) {
        return ThresholdKeysApiFp(this.configuration).thresholdKeyDelete(keyId, xKMSClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates and returns a new threshold key
     * @summary Generates and returns a new threshold key
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {GenerateKeyRequestDto} [generateKeyRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThresholdKeysApi
     */
    public thresholdKeyGenerate(xKMSClient?: string, generateKeyRequestDto?: GenerateKeyRequestDto, options?: RawAxiosRequestConfig) {
        return ThresholdKeysApiFp(this.configuration).thresholdKeyGenerate(xKMSClient, generateKeyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a threshold key metadata excluding the private key.
     * @summary Returns a threshold key based on a specific id
     * @param {string} keyId The threshold key id
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThresholdKeysApi
     */
    public thresholdKeyGet(keyId: string, xKMSClient?: string, options?: RawAxiosRequestConfig) {
        return ThresholdKeysApiFp(this.configuration).thresholdKeyGet(keyId, xKMSClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the AADRevocation group and KeyName for a specific threshold key.
     * @summary Updates a threshold key based on a specific id
     * @param {string} keyId The threshold key id
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {KeyRequestDto} [keyRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThresholdKeysApi
     */
    public thresholdKeyUpdate(keyId: string, xKMSClient?: string, keyRequestDto?: KeyRequestDto, options?: RawAxiosRequestConfig) {
        return ThresholdKeysApiFp(this.configuration).thresholdKeyUpdate(keyId, xKMSClient, keyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UsagePermissionsApi - axios parameter creator
 * @export
 */
export const UsagePermissionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates and returns a new usage permission
         * @summary Creates and returns a new usage permission
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {UsagePermissionRequestDto} [usagePermissionRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usagePermissionAdd: async (xKMSClient?: string, usagePermissionRequestDto?: UsagePermissionRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/usagepermissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(usagePermissionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a usage permission based on a specific id
         * @summary Deletes a usage permission based on a specific id
         * @param {string} id The usage permission entity id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usagePermissionDelete: async (id: string, xKMSClient?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('usagePermissionDelete', 'id', id)
            const localVarPath = `/usagepermissions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a usage permission based on a specific id
         * @summary Returns a usage permission based on a specific id
         * @param {string} id The usage permission id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usagePermissionGet: async (id: string, xKMSClient?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('usagePermissionGet', 'id', id)
            const localVarPath = `/usagepermissions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a usage permission based on a specific id
         * @summary Updates a usage permission based on a specific id
         * @param {string} id The usage permission id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {UsagePermissionRequestDto} [usagePermissionRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usagePermissionUpdate: async (id: string, xKMSClient?: string, usagePermissionRequestDto?: UsagePermissionRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('usagePermissionUpdate', 'id', id)
            const localVarPath = `/usagepermissions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(usagePermissionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all usage permissions
         * @summary Returns all usage permissions
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {SearchUsagePermissionsRequestDto} [searchUsagePermissionsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usagePermissionsSearch: async (xKMSClient?: string, searchUsagePermissionsRequestDto?: SearchUsagePermissionsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/usagepermissions/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchUsagePermissionsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsagePermissionsApi - functional programming interface
 * @export
 */
export const UsagePermissionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsagePermissionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates and returns a new usage permission
         * @summary Creates and returns a new usage permission
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {UsagePermissionRequestDto} [usagePermissionRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usagePermissionAdd(xKMSClient?: string, usagePermissionRequestDto?: UsagePermissionRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsagePermissionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usagePermissionAdd(xKMSClient, usagePermissionRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsagePermissionsApi.usagePermissionAdd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a usage permission based on a specific id
         * @summary Deletes a usage permission based on a specific id
         * @param {string} id The usage permission entity id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usagePermissionDelete(id: string, xKMSClient?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usagePermissionDelete(id, xKMSClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsagePermissionsApi.usagePermissionDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a usage permission based on a specific id
         * @summary Returns a usage permission based on a specific id
         * @param {string} id The usage permission id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usagePermissionGet(id: string, xKMSClient?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsagePermissionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usagePermissionGet(id, xKMSClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsagePermissionsApi.usagePermissionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates a usage permission based on a specific id
         * @summary Updates a usage permission based on a specific id
         * @param {string} id The usage permission id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {UsagePermissionRequestDto} [usagePermissionRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usagePermissionUpdate(id: string, xKMSClient?: string, usagePermissionRequestDto?: UsagePermissionRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsagePermissionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usagePermissionUpdate(id, xKMSClient, usagePermissionRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsagePermissionsApi.usagePermissionUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all usage permissions
         * @summary Returns all usage permissions
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {SearchUsagePermissionsRequestDto} [searchUsagePermissionsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usagePermissionsSearch(xKMSClient?: string, searchUsagePermissionsRequestDto?: SearchUsagePermissionsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchUsagePermissionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usagePermissionsSearch(xKMSClient, searchUsagePermissionsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsagePermissionsApi.usagePermissionsSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsagePermissionsApi - factory interface
 * @export
 */
export const UsagePermissionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsagePermissionsApiFp(configuration)
    return {
        /**
         * Creates and returns a new usage permission
         * @summary Creates and returns a new usage permission
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {UsagePermissionRequestDto} [usagePermissionRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usagePermissionAdd(xKMSClient?: string, usagePermissionRequestDto?: UsagePermissionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<UsagePermissionResponseDto> {
            return localVarFp.usagePermissionAdd(xKMSClient, usagePermissionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a usage permission based on a specific id
         * @summary Deletes a usage permission based on a specific id
         * @param {string} id The usage permission entity id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usagePermissionDelete(id: string, xKMSClient?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.usagePermissionDelete(id, xKMSClient, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a usage permission based on a specific id
         * @summary Returns a usage permission based on a specific id
         * @param {string} id The usage permission id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usagePermissionGet(id: string, xKMSClient?: string, options?: RawAxiosRequestConfig): AxiosPromise<UsagePermissionResponseDto> {
            return localVarFp.usagePermissionGet(id, xKMSClient, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a usage permission based on a specific id
         * @summary Updates a usage permission based on a specific id
         * @param {string} id The usage permission id
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {UsagePermissionRequestDto} [usagePermissionRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usagePermissionUpdate(id: string, xKMSClient?: string, usagePermissionRequestDto?: UsagePermissionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<UsagePermissionResponseDto> {
            return localVarFp.usagePermissionUpdate(id, xKMSClient, usagePermissionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all usage permissions
         * @summary Returns all usage permissions
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {SearchUsagePermissionsRequestDto} [searchUsagePermissionsRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usagePermissionsSearch(xKMSClient?: string, searchUsagePermissionsRequestDto?: SearchUsagePermissionsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<SearchUsagePermissionsResponseDto> {
            return localVarFp.usagePermissionsSearch(xKMSClient, searchUsagePermissionsRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsagePermissionsApi - object-oriented interface
 * @export
 * @class UsagePermissionsApi
 * @extends {BaseAPI}
 */
export class UsagePermissionsApi extends BaseAPI {
    /**
     * Creates and returns a new usage permission
     * @summary Creates and returns a new usage permission
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {UsagePermissionRequestDto} [usagePermissionRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsagePermissionsApi
     */
    public usagePermissionAdd(xKMSClient?: string, usagePermissionRequestDto?: UsagePermissionRequestDto, options?: RawAxiosRequestConfig) {
        return UsagePermissionsApiFp(this.configuration).usagePermissionAdd(xKMSClient, usagePermissionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a usage permission based on a specific id
     * @summary Deletes a usage permission based on a specific id
     * @param {string} id The usage permission entity id
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsagePermissionsApi
     */
    public usagePermissionDelete(id: string, xKMSClient?: string, options?: RawAxiosRequestConfig) {
        return UsagePermissionsApiFp(this.configuration).usagePermissionDelete(id, xKMSClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a usage permission based on a specific id
     * @summary Returns a usage permission based on a specific id
     * @param {string} id The usage permission id
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsagePermissionsApi
     */
    public usagePermissionGet(id: string, xKMSClient?: string, options?: RawAxiosRequestConfig) {
        return UsagePermissionsApiFp(this.configuration).usagePermissionGet(id, xKMSClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a usage permission based on a specific id
     * @summary Updates a usage permission based on a specific id
     * @param {string} id The usage permission id
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {UsagePermissionRequestDto} [usagePermissionRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsagePermissionsApi
     */
    public usagePermissionUpdate(id: string, xKMSClient?: string, usagePermissionRequestDto?: UsagePermissionRequestDto, options?: RawAxiosRequestConfig) {
        return UsagePermissionsApiFp(this.configuration).usagePermissionUpdate(id, xKMSClient, usagePermissionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all usage permissions
     * @summary Returns all usage permissions
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {SearchUsagePermissionsRequestDto} [searchUsagePermissionsRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsagePermissionsApi
     */
    public usagePermissionsSearch(xKMSClient?: string, searchUsagePermissionsRequestDto?: SearchUsagePermissionsRequestDto, options?: RawAxiosRequestConfig) {
        return UsagePermissionsApiFp(this.configuration).usagePermissionsSearch(xKMSClient, searchUsagePermissionsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserPermissionsApi - axios parameter creator
 * @export
 */
export const UserPermissionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a list of all User permissions within the Key Management System (KMS) 
         * @summary Returns all permissions for a give user
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPermissions: async (xKMSClient?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/GetUserPermissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserPermissionsApi - functional programming interface
 * @export
 */
export const UserPermissionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserPermissionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a list of all User permissions within the Key Management System (KMS) 
         * @summary Returns all permissions for a give user
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserPermissions(xKMSClient?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserPermissionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserPermissions(xKMSClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserPermissionsApi.getUserPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserPermissionsApi - factory interface
 * @export
 */
export const UserPermissionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserPermissionsApiFp(configuration)
    return {
        /**
         * Returns a list of all User permissions within the Key Management System (KMS) 
         * @summary Returns all permissions for a give user
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPermissions(xKMSClient?: string, options?: RawAxiosRequestConfig): AxiosPromise<UserPermissionsResponseDto> {
            return localVarFp.getUserPermissions(xKMSClient, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserPermissionsApi - object-oriented interface
 * @export
 * @class UserPermissionsApi
 * @extends {BaseAPI}
 */
export class UserPermissionsApi extends BaseAPI {
    /**
     * Returns a list of all User permissions within the Key Management System (KMS) 
     * @summary Returns all permissions for a give user
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserPermissionsApi
     */
    public getUserPermissions(xKMSClient?: string, options?: RawAxiosRequestConfig) {
        return UserPermissionsApiFp(this.configuration).getUserPermissions(xKMSClient, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VersionApi - axios parameter creator
 * @export
 */
export const VersionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the version of the current Key Management System (KMS) API.
         * @summary Returns the KMS API version
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kmsVersion: async (xKMSClient?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xKMSClient != null) {
                localVarHeaderParameter['X-KMS-Client'] = String(xKMSClient);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VersionApi - functional programming interface
 * @export
 */
export const VersionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VersionApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the version of the current Key Management System (KMS) API.
         * @summary Returns the KMS API version
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kmsVersion(xKMSClient?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kmsVersion(xKMSClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VersionApi.kmsVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VersionApi - factory interface
 * @export
 */
export const VersionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VersionApiFp(configuration)
    return {
        /**
         * Returns the version of the current Key Management System (KMS) API.
         * @summary Returns the KMS API version
         * @param {string} [xKMSClient] Custom header to identify the client calling kms
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kmsVersion(xKMSClient?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.kmsVersion(xKMSClient, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VersionApi - object-oriented interface
 * @export
 * @class VersionApi
 * @extends {BaseAPI}
 */
export class VersionApi extends BaseAPI {
    /**
     * Returns the version of the current Key Management System (KMS) API.
     * @summary Returns the KMS API version
     * @param {string} [xKMSClient] Custom header to identify the client calling kms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VersionApi
     */
    public kmsVersion(xKMSClient?: string, options?: RawAxiosRequestConfig) {
        return VersionApiFp(this.configuration).kmsVersion(xKMSClient, options).then((request) => request(this.axios, this.basePath));
    }
}



